export const translations = {
  fa: {
    steps: {
      channel: {
        title: 'در این قسمت شما باید اطلاعات کانال‌های ارتباطی خود را مدیریت کنید و هر کانال را که میخواهید فعال یا غیرفعال کنید',
        instagram: {
          step1: 'با استفاده از این گزینه می‌توانید حساب اینستاگرام خود را به آیدا متصل کنید. پس از اتصال، هر زمان که نیاز داشتید، با فعال‌سازی یا غیرفعال‌سازی این قابلیت، امکان استفاده از خدمات و قابلیت‌های آیدا در اینستاگرام برای شما فراهم خواهد بود.',
          step2: 'با انتخاب این گزینه، قابلیت‌های آیدا در حساب اینستاگرام شما فعال می‌شود. پس از فعال‌سازی، آیدا می‌تواند در مدیریت پیام‌ها، پاسخ‌گویی به مشتریان و معرفی محصولات در اینستاگرام به شما کمک کند.'
        },
        telegram: {
          step1: 'در این بخش با وارد کردن توکن مربوط به ربات تلگرام خود، می‌توانید قابلیت اتصال آیدا به تلگرام را فعال یا غیرفعال نمایید. پس از فعال‌سازی، آیدا امکان ارائه خدمات و پاسخ‌گویی از طریق تلگرام را خواهد داشت.',
        },
        website: {
          step1: 'در این بخش، با وارد کردن شناسه چت‌باکس و آدرس وب‌سایت خود، می‌توانید قابلیت استفاده از خدمات آیدا را در وب‌سایت فعال یا غیرفعال نمایید. با این اتصال، آیدا به‌عنوان دستیار هوشمند در سایت شما در دسترس کاربران خواهد بود.',
        },
        bale: {
          step1: 'در این بخش، با وارد کردن توکن مربوط به ربات بله خود، می‌توانید قابلیت اتصال آیدا به بله را فعال یا غیرفعال نمایید. پس از فعال‌سازی، آیدا امکان ارائه خدمات و پاسخ‌گویی از طریق بله را خواهد داشت',
        },
      },
      knowledge: {
        title: 'در این بخش می‌توانید دانش و اطلاعاتی را که به حافظه آیدا افزوده شده است مشاهده نمایید. این بخش به شما امکان مدیریت و مرور محتوای ذخیره‌شده در آیدا را می‌دهد.',
        step1: 'با استفاده از این دکمه می‌توانید دانش و اطلاعات جدیدی را به حافظه آیدا اضافه نمایید. این قابلیت به شما امکان می‌دهد محتوای مرتبط با کسب‌وکار خود را برای یادگیری و بهبود عملکرد آیدا به‌روزرسانی کنید',
        step2: 'با استفاده از این دکمه می‌توانید تمامی اطلاعات ذخیره‌شده در حافظه آیدا را حذف نمایید. این عمل موجب پاک‌سازی کامل محتوا و دانش افزوده‌شده به آیدا خواهد شد.',
        step3: 'با استفاده از این دکمه می‌توانید یک مورد خاص از دانش ذخیره‌شده در حافظه آیدا را انتخاب و حذف کنید. این قابلیت به شما امکان می‌دهد محتوای مشخصی را بدون پاک‌سازی کامل حافظه مدیریت کنید. توجه داشته باشید که زمانی که هنوز دانشی ذخیره نشده است، این گزینه نمایش داده نمی‌شود.',
      },
      profile: {
        title: `این بخش به شما امکان می‌دهد اطلاعات پروفایل حساب کاربری خود را که مربوط به ادمین است، از جمله نام و نام خانوادگی، شماره تلفن و سمت شغلی، ویرایش کنید`,
      },
      profile_onboarding: {
        title: 'در این بخش شما اطلاعات پروفایل خود را وارد کنید.',
      },
      payments: {
        title: 'در این بخش می‌توانید تاریخچه پرداخت‌های خود را به‌طور کامل مشاهده کنید.',
        step1: 'با استفاده از این فیلدهای تاریخ، می‌توانید بازه شروع و پایان پرداخت‌ها را تعیین کرده و پرداخت‌هایی که در آن بازه انجام شده‌اند را مشاهده کنید.',
        step2: 'جزئیات کامل اطلاعات و سابقه پرداخت‌ها در این بخش قابل مشاهده است.',
      },
      business: {
        title: 'در این بخش می‌توانید اطلاعات کسب‌وکار خود را مدیریت و ویرایش کنید. ثبت دقیق این اطلاعات به آیدا کمک می‌کند تا مجموعه شما را بهتر بشناسد و خدمات بهتری به شما ارائه دهد.',
        step1: 'در این بخش می‌توانید نام کسب‌وکار خود را وارد کرده یا ویرایش کنید.',
        step2: 'در این قسمت امکان وارد کردن نوع کسب‌وکار شما فراهم شده است.',
        step3: 'اندازه کسب‌وکار شما در این بخش قابل مشاهده و تعیین است.',
        step4: 'در این قسمت می‌توانید آدرس کسب‌وکار خود را وارد کنید.',
        step5: 'در این بخش می‌توانید توضیحات مربوط به کسب‌وکار خود را وارد کنید. هر اطلاعاتی که به نظر شما برای آیدا مفید است اینجا ثبت کنید؛ زیرا کیفیت عملکرد آیدا به دقت اطلاعات وارد شده توسط شما بستگی دارد.',
        step6: 'در این قسمت می‌توانید توضیحات تکمیلی مربوط به کسب‌وکار خود را وارد کنید.',
      },
      business_onboarding: {
        title: 'در این بخش اطلاعات کسب و کار خود را وارد کنید. این اطلاعات به آیدا کمک میکند که تا مجموعه شما را بهتر بشناسد و بهتر بتواند به شما کمک کند.',
        step1: 'در این فیلد نام کسب و کار خود را وارد کنید.',
        step2: 'در این فیلد نوع کسب و کار خود را وارد کنید.',
        step3: 'در این فیلد اندازه کسب و کار خود را وارد کنید.',
        step4: 'در این فیلد آدرس کسب و کار خود را وارد کنید.',
        step5: 'با استفاده از این فیلد می‌توانید توضیحات کسب و کار خود را وارد کنید. هرچه را که فکر می کنید لازم است که آیدا بداند در اینجا بنویسید کیفیت آیدا به اطلاعاتی که شما وارد میکنید وابسته است.',
        step6: 'اطلاعات اضافی در کسب و کار خود را در اینجا وارد کنید.',
      },
      service: {
        title: 'در این بخش می‌توانید اطلاعات خدمات ارائه‌شده توسط کسب‌وکار خود را مدیریت و ویرایش کنید.',
        step1: 'در این بخش می‌توانید نوع خدمات ارائه‌شده توسط کسب‌وکار خود را مشخص کنید. اگر خدمات شما در هیچ‌یک از دسته‌بندی‌ها قرار نمی‌گیرد، گزینه "سایر" را انتخاب کرده و توضیحات کامل را در بخش توضیحات خدمات وارد نمایید.',
        step2: 'در این بخش می‌توانید توضیحات مربوط به خدمات ارائه‌شده توسط کسب‌وکار خود را وارد کنید. لطفاً اطلاعات را به‌طور کامل و دقیق ثبت کنید، زیرا این داده‌ها نقش مهمی در بهبود عملکرد آیدا دارند.',
        step3: 'در این بخش می‌توانید مخاطبان خدمات کسب‌وکار خود را مشخص کنید. این مخاطبان می‌توانند مشتریان، شرکت‌ها یا سایر افراد باشند.',
      },
      service_onboarding: {
        title: 'در این بخش اطلاعات خدمات خود را وارد کنید.',
        step1: 'با استفاده از این فیلد نوع خدمات خود را وارد کنید. نوع خدمات میتواند مشاوره، آموزش یا خدمات باشد. چنانچه خارج از این سه نوع هستید گزینه سایر را انخاب کنید و توضیحات دقیق را در فیلد توضیحات خدمات بنویسید.',
        step2: 'با استفاده از این فیلد توضیحات خدمات خود را وارد کنید. توضیحات خدمات باید دقیق و کامل باشد.',
        step3: 'با استفاده از این فیلد مخاطبان خدمات خود را وارد کنید. مخاطبان خدمات میتواند مشتریان، شرکتها یا سایر افراد باشد.',
      },
      behavior: {
        title: 'یکی از قابلیت‌های جذاب آیدا، امکان شخصی‌سازی آن است. می‌توانید آیدا را برای کسب‌وکار خود تنظیم کنید تا پاسخ‌ها مطابق میل شما ارائه شوند.',
        step1: 'در این بخش می‌توانید سبک مکالمه آیدا با مخاطبین خود را تعیین کنید.',
        step2: 'در این بخش می‌توانید روش فروش آیدا را مشخص کنید تا آیدا مطابق روش انتخابی، فروش خود را انجام دهد. هر روش ویژگی‌ها و ساختار خاص خود را دارد؛ بنابراین آن را بر اساس نیازها و ملاحظات کسب‌وکارتان تنظیم کنید.',
        step3: 'در این بخش می‌توانید حالت پاسخگویی آیدا را مشخص کنید تا آیدا مطابق حالت انتخابی، پاسخ خود را انجام دهد.',
        step4: 'در این بخش می‌توانید طول پاسخ های آیدا را مشخص کنید تا آیدا مطابق طول انتخابی، پاسخ خود را انجام دهد.',
        step5: 'در این بخش می‌توانید زمان استراحت آیدا را تنظیم کنید که آیدا در چه زمانی به مشتریان پاسخ ندهد. با استفاده از دکمه های اضافه کردن شما میتوانید تایم مورد نظر خود را که نمی خواهید در اون بازه آیدا جوابی بدهد را وارد کرده و سپس با استفاده از دکمه سبز زمان هایی که وارد کرده اید را ذخیره کنید. در جدول هم تایم های که مشخص کرده اید نمایش داده می شود',
      },
      autoResponse: {
        title: 'این بخش به شما امکان می‌دهد پاسخ‌های از پیش تعیین‌شده‌ای برای سوالات، کلمات یا جملات مشخص تعریف کنید.',
        step1: 'با استفاده از این دکمه می‌توانید پاسخ‌های از پیش تعیین‌شده برای کلمات یا جملات مشخص را به آیدا اضافه کنید.',
        step2: 'با استفاده از این دکمه می‌توانید پاسخ‌های از قبل تعیین‌شده را حذف کنید. این عمل موجب پاک‌سازی کامل تمامی پاسخ‌های از پیش تعیین‌شده خواهد شد.',
        step3: 'با استفاده از این دکمه می‌توانید یک مورد خاص از پاسخ‌های از پیش تعیین‌شده را انتخاب و حذف کنید. این قابلیت به شما اجازه می‌دهد پاسخ‌های مشخص را بدون پاک‌سازی کامل همه پاسخ‌ها مدیریت نمایید. توجه داشته باشید که زمانی که هنوز موردی ذخیره نشده است، این گزینه نمایش داده نمی‌شود.',
      },
      conversation: {
        title: 'این بخش به شما امکان می‌دهد مکالمات آیدا با کاربران را مشاهده کنید. تمام کانال‌هایی که آیدا در آن‌ها با کاربران شما تعامل داشته است، در اینجا نمایش داده می‌شوند.',
      },
      chatbox: {
        step1: 'در قسمت چت باکس، شما یک نسخه آزمایشی از آیدا را در اختیار دارید و می‌توانید با آن گفتگو کنید. تمامی مکالمات شما در بخش تاریخچه مکالمات ذخیره می‌شوند',
        step2: 'در بخش مستندات می‌توانید کدهای مربوط به چت باکس را مشاهده کنید. برای اطلاعات بیشتر درباره اتصال آیدا به وبسایت خود، به مستندات مربوطه مراجعه نمایید.',
        step3: 'در بخش تنظیمات چت باکس می‌توانید موقعیت چت باکس را تنظیم کنید. سپس با استفاده از کد درست شده میتوانید چت باکس خود را به وبسایت خود اضافه کنید.',
      },
      dashboard: {
        title: 'خوش آمدید به داشبورد آیدا! در اینجا می‌توانید آمار کلی دانش و عملکرد سیستم خود را مشاهده کنید.',
        videoButton:'دکمه ویدیو در هر صفحه آموزش ویدیویی اون صفحه رو به شما نمایش می دهد ، شما با استفاده از این دکمه میاوانید تمام جزئیات اون صفحه رو متوجه بشوید.',
        helpButton: 'دکمه راهنما در هر صفحه توضیحات کامل آن بخش را در اختیار شما قرار می‌دهد.',
        sidebar: 'از طریق این منو می‌توانید به تمامی تنظیمات و بخش‌های آیدا دسترسی داشته باشید.',
        subscriptionInfo: 'در این بخش می‌توانید نوع پلن و تعداد روزهای باقی‌مانده از اشتراک خود را مشاهده کنید.',
        logoutButton: 'با استفاده از این دکمه می‌توانید از حساب کاربری خود خارج شوید.',
        knowledgeStats: 'در این بخش می‌توانید تعداد ورودی‌ها، کاراکترها و توکن‌های استفاده شده و همچنین هزینه تخمینی مصرف شده برای حساب کاربری خود را مشاهده کنید.',
        totalEntries: 'تعداد کل ورودی‌های دانش شما در اینجا نمایش داده می‌شود.',
        hamburgerMenu: 'از طریق این منو می‌توانید به تمامی تنظیمات و بخش‌های آیدا دسترسی داشته باشید.',
        userInfo: 'اینجا اطلاعات شما مثل نام، ایمیل و شماره تلفن نمایش داده میشه. اگه خواستید چیزی رو تغییر بدید، روی آیکون چرخ‌دنده بالا سمت چپ همین باکس بزنید تا به صفحه پروفایل برید و اطلاعات‌تون رو ویرایش کنید.',
        activeChannels: 'توی این بخش همه کانال‌های ارتباطی‌تون با مشتری‌ها رو می‌بینید. وضعیت هر کانال جلوی اون نوشته شده:سبز یعنی «فعال» و آماده پاسخ‌گویی، قرمز یعنی «غیرفعال».با زدن روی چرخ‌دنده بالا، وارد صفحه مدیریت کانال‌ها می‌شید و می‌تونید اون‌ها رو فعال یا غیرفعال کنید.',
        knowledgeCount: 'این بخش نشون میده تا حالا چند تا «دانش» ثبت کردید. پایین‌تر هم آخرین دانش‌های شما نمایش داده می‌شن. با کلیک روی آیکون چرخ‌دنده می‌تونید برید به صفحه دانش‌ها و اون‌ها رو مدیریت یا ویرایش کنید.',
        conversations: 'این نمودار میله‌ای نشون میده تو هر کانال چند تا پیام رد و بدل شده. بالای هر میله، تعداد دقیق پیام‌ها نوشته شده. با زدن روی چرخ‌دنده بالا، وارد صفحه تاریخچه گفتگوها می‌شید تا جزئیات همه پیام‌ها رو ببینید.',
        conversationsLast7Days: 'این قسمت مشابه بخش قبلیه، فقط اطلاعات مربوط به هفت روز اخیر رو نشون میده. با نگاه به این نمودار می‌تونید بفهمید این هفته کدوم کانال بیشترین فعالیت رو داشته.',
        tokenUsage: 'اینجا می‌تونید ببینید آیدا چه مقدار توکن برای شما استفاده کرده. تعداد توکن‌های ورودی و خروجی به‌صورت نمودار دایره‌ای نشون داده شده تا راحت‌تر بتونید حجم مصرفی‌تون رو بسنجید. این بخش برای کنترل و مدیریت مصرف هوش مصنوعی خیلی کاربردیه.',
        activeIntegrations: 'این بخش فهرست دوستان فعالتون رو نشون میده؛ کسایی که آیدا با اون‌ها هم در ارتباطه. اگر خواستید دوستی اضافه یا حذف کنید، روی آیکون چرخ‌دنده بزنید تا وارد صفحه مدیریت دوستان بشید. از اونجا می‌تونید تمام ارتباط‌های فعالتون رو کنترل کنید.',
        recentPayments: 'در این قسمت لیستی از آخرین پرداخت‌هاتون نمایش داده میشه. می‌تونید ببینید هر پرداخت مربوط به چی بوده و مبلغش چقدره. با آیکون چرخ‌دنده بالا هم می‌تونید برید به صفحه تاریخچه پرداخت‌ها و جزئیات کامل‌تر رو ببینید.',
      },
      subscription: {
        step1: 'در این قسمت مدل آیدا خود را انتخاب کنید و پنل ها و توضیحات هر کدام از آیدا ها را مشاهده کنید.',
        step2: 'در این قسمت شما میتوانید مدت زمان اشتراک آیدا را انتخاب کنید.',
      },
      marketplace: {
        title: 'در این بخش می‌توانید دوستان آیدا که قابلیت اتصال به آن را دارند مشاهده کنید. با فعال‌سازی آن‌ها، می‌توانید از قابلیت‌هایشان در آیدا بهره‌مند شوید.',
      },
      myIntegrations: {
        title: 'در این بخش می‌توانید وضعیت فعال یا غیرفعال بودن دوستان آیدا برای حساب کاربری خود را مشاهده کنید.',
      }
    },
    video: {
      dashboard: 'آموزش داشبورد',
      profile: 'آموزش پروفایل',
      business: 'آموزش کسب و کار',
      payments: 'آموزش پرداخت ها',
      channel: 'آموزش کانال ها',
      aidaSetting: 'آموزش تنظیمات آیدا',
      knowledge: 'آموزش دانش آیدا',
      autoResponse: 'آموزش پاسخگویی هوشمند',
      chatHistory: 'آموزش تاریخچه مکالمات',
      chatBox: 'آموزش چت باکس',
      marketPlace: 'آموزش اطرافیان آیدا',
      myIntegrations: 'آموزش دوستان آیدا',
      signup: 'آموزش ثبت نام',
    },
    // Auth
    auth: {
      login: {
        title: 'ورود به حساب کاربری',
        phoneStep: 'ورود شماره تلفن',
        emailStep: 'ورود ایمیل',
        otpStep: 'تایید کد پیامکی',
        phoneLabel: 'شماره تلفن',
        phonePlaceholder: '+989123456789',
        emailLabel: 'ایمیل',
        emailPlaceholder: 'example@gmail.com',
        phoneMethod: 'شماره تلفن',
        emailMethod: 'ایمیل',
        otpLabel: 'کد تایید',
        otpPlaceholder: 'کد ۶ رقمی',
        sendOtp: 'ارسال کد تایید',
        verifyAndLogin: 'تایید و ورود',
        noAccount: 'حساب کاربری ندارید؟',
        signupLink: 'ثبت نام کنید',
        userNotFound: 'کاربری با این شماره تلفن وجود ندارد. لطفا ابتدا ثبت نام کنید.',
        signup: 'ثبت نام',
        validationError: 'اطلاعات وارد شده صحیح نیست',
        tooManyRequests: 'درخواست‌های زیادی ارسال کرده‌اید. لطفاً کمی صبر کنید',
        serverError: 'خطای سرور. لطفاً دوباره تلاش کنید',
        serviceUnavailable: 'سرویس در دسترس نیست. لطفاً بعداً تلاش کنید',
        networkError: 'خطای شبکه. لطفاً اتصال اینترنت خود را بررسی کنید',
        genericError: 'خطایی رخ داده است. لطفاً دوباره تلاش کنید',
      },
      signup: {
        title: 'ثبت نام در آیدا',
        phoneStep: 'ثبت نام شماره تلفن',
        emailStep: 'ثبت نام ایمیل',
        otpStep: 'تایید کد پیامکی',
        phoneLabel: 'شماره تلفن',
        phonePlaceholder: '+989123456789',
        emailLabel: 'ایمیل',
        emailPlaceholder: 'example@gmail.com',
        phoneMethod: 'شماره تلفن',
        emailMethod: 'ایمیل',
        otpLabel: 'کد تایید',
        otpPlaceholder: 'کد ۶ رقمی',
        sendOtp: 'ارسال کد تایید',
        verifyAndSignup: 'تایید و ثبت نام',
        haveAccount: 'حساب کاربری دارید؟',
        loginLink: 'ورود کنید',
      },
      errors: {
        badRequest: 'درخواست نامعتبر است. لطفاً اطلاعات وارد شده را بررسی کنید.',
        validationError: 'اطلاعات وارد شده صحیح نیست. لطفاً فیلدهای اجباری را پر کنید.',
        tooManyRequests: 'درخواست‌های زیادی ارسال کرده‌اید. لطفاً کمی صبر کنید.',
        serverError: 'خطای سرور. لطفاً دوباره تلاش کنید.',
        serviceUnavailable: 'سرویس در دسترس نیست. لطفاً بعداً تلاش کنید.',
        networkError: 'خطای شبکه. لطفاً اتصال اینترنت خود را بررسی کنید.',
        unknownError: 'خطای نامشخص. لطفاً دوباره تلاش کنید.',
        invalidOtp: 'کد تایید نامعتبر است. لطفاً کد صحیح را وارد کنید.',
        otpExpired: 'کد تایید منقضی شده است. لطفاً کد جدیدی درخواست کنید.',
        userAlreadyExists: 'کاربری با این اطلاعات قبلاً ثبت نام کرده است.',
        invalidPhoneNumber: 'شماره تلفن نامعتبر است. لطفاً شماره صحیح را وارد کنید.',
        invalidEmail: 'ایمیل نامعتبر است. لطفاً ایمیل صحیح را وارد کنید.',
        userNotFound: 'کاربری با این اطلاعات یافت نشد. لطفاً ابتدا ثبت نام کنید.',
        waitRequest: 'لطفا چند دقیقه دیگر دوباره تلاش کنید.',
        
      },
      language: {
        label: 'زبان',
        fa: 'فارسی',
        en: 'English',
      },
    },
    // Dashboard
    dashboard: {
      title: 'داشبورد',
      userInfo: {
        title: 'اطلاعات شخصی',
        fullName: 'نام کامل',
        email: 'ایمیل',
        phoneNumber: 'شماره تلفن',
        languagePreference: 'زبان',
        createdAt: 'تاریخ ثبت نام',
        notSet: 'تنظیم نشده',
      },
      systemPrompt: {
        title: 'شناخت آیدا از شما',
        noSystemPrompt: 'آیدا هنوز شناختی از کسب و کار شما پیدا نکرده است! لطفا از صفحه پروفایل و کسب و کار اقدام به کامل کردن اطلاعات خود کنید.',
        showMore: 'نمایش بیشتر',
        close: 'بستن',
      },
      activeChannels: {
        title: 'کانال‌های من',
        telegram: 'تلگرام',
        bale: 'بله',
        instagram: 'اینستاگرام',
        website: 'وبسایت',
        kavenegar: 'کاوه‌نگار',
        instagram_comment: 'کامنت اینستاگرام',
        noChannels: 'هیچ کانالی فعال نیست',
      },
      knowledgeCount: {
        title: 'تعداد دانش',
        count: 'دانش',
        lasts_knowledge: 'آخرین دانش‌ها',
        type: 'نوع',
        content: 'محتوا',
        noKnowledge: 'جدول دانش در حال حاضر خالی است',
      },
      conversations: {
        title: 'تاریخچه گفتگوها',
        totalMessages: 'کل پیام‌ها',
        byChannel: 'بر اساس کانال',
        noConversations: 'گفتگویی یافت نشد',
      },
      conversationsLast7Days: {
        title: 'گفتگوهای ۷ روز اخیر',
        messages: 'پیام',
        noConversations: 'گفتگویی یافت نشد',
      },
      tokenUsage: {
        title: 'مصرف توکن',
        inputTokens: 'توکن‌های ورودی',
        outputTokens: 'توکن‌های خروجی',
        totalTokens: 'کل توکن‌ها',
        noTokensExchanged: 'هنوز توکنی رد و بدل نشده است',
      },
      activeIntegrations: {
        title: 'دوستان فعال',
        count: 'دوست فعال',
        noActiveIntegrations: 'هیچ دوست فعالی وجود ندارد',
      },
      recentPayments: {
        title: 'آخرین پرداخت‌ها',
        amount: 'مبلغ',
        plan: 'اشتراک',
        refId: 'کد پیگیری',
        noPayments: 'پرداختی یافت نشد',
      },
      error: {
        fetchError: 'خطا در دریافت اطلاعات داشبورد. لطفا دوباره تلاش کنید.',
        sessionExpired: 'جلسه شما منقضی شده است. لطفاً دوباره وارد شوید.',
      },
      chatbox: {
        welcomeParagraphs: [
          'سلام 👋\nبه {bold}پنل آیدا{bold} خوش آمدید.',
          'من {bold}آیدا{bold} هستم؛ دستیار هوشمند فروش شما \nاینجا کنار شما هستم تا به کمک هوش مصنوعی، ارتباط با مشتریان‌تان را بهتر کنید، سریع‌تر پاسخ بدهید و فروش بیشتری داشته باشید.',
          'برای اینکه بتوانم پاسخ‌های دقیق‌تر و حرفه‌ای‌تری به مشتریان شما بدهم، کافیست دانش کسب‌وکارتان را در بخش {bold}دانش آیدا{bold} [جایگاه آیکون دانش] به من آموزش دهید.',
          'در این قسمت می‌توانید فایل‌های PDF، Excel، لینک وبسایت، متن و اطلاعات موردنیاز خود را به پایگاه دانش من اضافه کنید تا پاسخ‌هایم همیشه مطابق اطلاعات و قوانین کسب‌وکار شما باشد.',
          'در بخش {bold}تنظیمات آیدا{bold} [جایگاه آیکون تنظیمات] می‌توانید نحوه عملکرد من را شخصی‌سازی کنید.',
          'از تنظیم کانال‌های ارتباطی گرفته تا رفتار من در گفتگو با مشتریان، پاسخ به پیام‌های پرتکرار، مدیریت دوستان آیدا و قوانینی که باید هنگام پاسخ‌گویی رعایت کنم، همگی از این قسمت قابل مدیریت هستند.',
          'در قسمت {bold}گفتگوها{bold} [جایگاه آیکون گفتگو] می‌توانید تمام گفتگوهای انجام‌شده با مشتریان را مشاهده و بررسی کنید.',
          'گفتگوها بر اساس کانال‌های مختلف دسته‌بندی شده‌اند تا سریع‌تر به مکالمات موردنظر خود دسترسی داشته باشید و بتوانید کیفیت پاسخ‌های من را بهتر مدیریت کنید.',
          'در بخش {bold}پروفایل{bold} [جایگاه آیکون پروفایل] می‌توانید اطلاعات شخصی و اطلاعات کسب‌وکار خود را تکمیل کنید.',
          'هرچه اطلاعات دقیق‌تری از کسب‌وکار شما داشته باشم، بهتر می‌توانم مشتریان شما را درک کنم و پاسخ‌های مناسب‌تری ارائه دهم.',
          'در قسمت {bold}چت‌باکس{bold} [جایگاه آیکون چت‌باکس] می‌توانید تنظیمات چت‌باکسی که قرار است در سایت خود قرار دهید را به‌صورت کامل مدیریت کنید.',
          'پس از انجام تنظیمات، کد Script اختصاصی شما تولید می‌شود و می‌توانید با استفاده از آموزش‌های همان بخش، آن را در وبسایت خود قرار دهید تا من آماده گفتگو با مشتریان شما باشم.',
          'اگر در هر بخشی سوال یا مشکلی داشتید، از طریق چت‌باکسی که در این صفحه قرار دارد با من صحبت کنید 💬\nمن همیشه آماده پاسخ‌گویی به سوالات شما هستم.',
          'امیدواریم تجربه‌ای لذت‌بخش و مفید در کنار آیدا داشته باشید ✨',
        ],
        clearChatHistory: 'پاک کردن تاریخچه چت',
        clearHistory: 'پاک کردن تاریخچه چت',
        title: 'آیدا',
        chatboxPlaceholder: 'پیام خود را وارد کنید...',
        errorMessage: 'متأسفانه خطایی رخ داد. لطفاً دوباره تلاش کنید.',
        isTyping: 'در حال تایپ...',
        howCanIHelpYou: 'سلام به شما :) \nچطور میتونم کمکتون کنم؟',
      }
    },
    // Menu
    menu: {
      dashboard: 'داشبورد',
      you: 'شما',
      payments: 'پرداخت‌ها',
      profile: 'پروفایل',
      business: 'کسب و کار',
      services: 'خدمات',
      aida: 'آیدا',
      channels: 'کانال‌ها',
      behavior: 'رفتار',
      knowledgeCenter: 'مرکز دانش',
      conversation: 'مکالمه',
      conversationHistory: 'تاریخچه مکالمات',
      chatbox: 'چت باکس',
      marketplace: 'اطرافیان آیدا',
      myIntegrations: 'دوستان آیدا',
      subscriptionRenewal: 'تمدید اشتراک',
      addKnowledge: 'افزودن دانش',
      knowledgeStats: 'آمار دانش',
      deleteAllKnowledge: 'حذف تمام دانش',
      knowledgeList: 'لیست دانش',
      knowledgeGraph: 'نمودار دانش',
      daysRemaining: 'روز باقیمانده',
      logout: 'خروج',
      automateResponse: 'پاسخگویی هوشمند',
      automateResponseBot: 'پاسخ خودکار',
      salesCampaign: 'کمپین فروش',
    },
    // Marketplace
    marketplace: {
      title: 'اطرافیان آیدا',
      description: 'دوستان قدرتمند آیدا را برای تقویت قابلیت‌هایش کشف و اضافه کنید.',
      searchPlaceholder: 'جستجوی دوستان...',
      learnMore: 'بیشتر بدانید',
      addToAida: 'اضافه کردن دوست',
      monthlyPrice: 'ماهانه',
      active: 'فعال',
      inactive: 'غیرفعال',
      loading: 'در حال بارگذاری دوستان...',
      error: 'خطا در بارگذاری دوستان. لطفا دوباره تلاش کنید.',
      empty: 'هیچ دوستی یافت نشد',
      emptyDescription: 'شاید اسم دوستش رو اشتباه زدی؟؟!!',
      integrationAdded: 'دوست با موفقیت به آیدای شما اضافه شد!',
      integrationAddError: 'افزودن دوست با خطا مواجه شد',
      configurationRequirements: 'الزامات پیکربندی',
      requiredFields: 'فیلدهای اجباری:',
      optionalFields: 'فیلدهای اختیاری:',
      sensitiveField: 'حساس',
      defaultValue: 'پیش‌فرض',
      termsAndConditions: 'شرایط و ضوابط',
      visitWebsite: 'مشاهده وبسایت',
      loadingDetails: 'در حال بارگذاری جزئیات دوست...',
      failedToLoadDetails: 'بارگذاری جزئیات دوست ناموفق بود',
      tryAgain: 'دوباره امتحان کنید',
      descriptionTitle: 'توضیحات',
      previous: 'قبلی',
      next: 'بعدی',
      page: 'صفحه',
      of: 'از',
      myIntegrations: {
        title: 'دوستان آیدا',
        description: 'دوستان آیدای خود را مدیریت و پیکربندی کنید.',
        filterAll: 'همه',
        filterActive: 'فعال',
        filterInactive: 'غیرفعال',
        configureIntegration: 'پیکربندی دوست',
        editConfiguration: 'ویرایش پیکربندی',
        setupIntegration: 'راه‌اندازی دوست',
        configured: 'پیکربندی شده',
        setupRequired: 'نیاز به راه‌اندازی',
        notes: 'یادداشت‌ها:',
        configuration: 'پیکربندی:',
        noConfiguration: 'هیچ پیکربندی تنظیم نشده',
        addedDate: 'اضافه شده:',
        updatedDate: 'بروزرسانی شده:',
        remove: 'حذف',
        removeConfirm: 'آیا مطمئن هستید که می‌خواهید این دوست را حذف کنید؟ این عمل قابل بازگشت نیست.',
        removeIntegration: 'حذف دوست',
        cancel: 'انصراف',
        integrationRemoved: 'دوست با موفقیت حذف شد!',
        integrationRemoveError: 'حذف دوست با خطا مواجه شد',
        configurationSaved: 'پیکربندی دوست با موفقیت ذخیره شد!',
        configurationSaveError: 'ذخیره پیکربندی با خطا مواجه شد',
        empty: 'هیچ دوستی یافت نشد',
        emptyActive: 'شما هیچ دوست فعالی ندارید.',
        emptyInactive: 'شما هیچ دوست غیرفعالی ندارید.',
        emptyAll: 'شما هنوز هیچ دوستی اضافه نکرده‌اید.',
        browseMarketplace: 'مرور اطرافیان آیدا',
        loadingIntegrations: 'در حال بارگذاری دوستان شما...',
        noIntegrationsFound: 'هیچ دوستی یافت نشد',
        noActiveIntegrations: 'شما هیچ دوست فعالی ندارید.',
        noInactiveIntegrations: 'شما هیچ دوست غیرفعالی ندارید.',
        noIntegrationsYet: 'شما هنوز هیچ دوستی اضافه نکرده‌اید.',
        failedToLoad: 'بارگذاری دوستان ناموفق بود',
        failedToRemove: 'حذف دوست ناموفق بود',
        tryAgain: 'دوباره امتحان کنید',
        filters: {
          all: 'همه',
          active: 'فعال',
          inactive: 'غیرفعال',
        },
        pagination: {
          previous: 'قبلی',
          next: 'بعدی',
          pageInfo: 'صفحه {{page}} از {{totalPages}}',
        },
        configModal: {
          title: 'پیکربندی',
          requiredConfig: 'پیکربندی اجباری',
          optionalConfig: 'پیکربندی اختیاری',
          notes: 'یادداشت‌ها',
          notesLabel: 'یادداشت‌های دوست',
          notesPlaceholder: 'یادداشت‌هایی درباره این پیکربندی دوست اضافه کنید...',
          required: 'اجباری',
          cancel: 'انصراف',
          save: 'ذخیره پیکربندی',
          saving: 'در حال ذخیره...',
          enableOption: 'فعال‌سازی این گزینه',
          selectOption: 'انتخاب یک گزینه',
          invalidFormat: 'فرمت نامعتبر',
          fieldRequired: 'اجباری است',
        },
      },
      connections: {
        didarAdvancedTab: 'تنظیمات پیشرفته دیدار',
        didarMissingIntegration:
          'برای رفتن به تنظیمات فرم دیدار باید ابتدا دیدار را به دوستان خود اضافه کنید.',
        didarAdvanced: {
          supplementaryLabel: 'شرایط دریافت اطلاعات',
          supplementaryFieldLegend: 'شرایط دریافت اطلاعات',
          supplementaryPlaceholder:
            'مشخص کنید این فرم در چه شرایطی یا چه زمانی باید از کاربر دریافت شود...',
          submitIncomplete: 'لطفاً توضیحات همه فیلدها و شرایط دریافت فرم را کامل کنید.',
          submitNoIntegration: 'دوست فعال دیدار یافت نشد. لطفاً ابتدا دیدار را در دوستان آیدا فعال کنید.',
          newFormConfirmTitle: 'ثبت فرم جدید دیدار',
          newFormConfirmMessage:
            'شما قبلاً یک فرم ثبت‌شده داشته‌اید و اکنون درخواست پر کردن فرم دیگری را دارید. برای ثبت و پر کردن فرم جدید، اطلاعات فرم قبلی پاک می‌شود. آیا مایل به انجام این کار هستید؟',
          newFormConfirmYes: 'بله، فرم جدید را می‌خواهم',
          newFormConfirmCancel: 'انصراف',
          submitPreviewTitle: 'خروجی JSON (تست)',
          help: {
            title: 'اطلاعات بیشتر',
            pageSetupTitle: 'توضیحات صفحه تنظیم فرم دیدار و تعریف فیلدهای فرم',
            pageSetupP1:
              'در این صفحه، یک لینک (URL) مربوط به فرم دیدار وارد می‌شود و سیستم به صورت خودکار فرم موجود در آن آدرس را شناسایی و نمایش می‌دهد.',
            pageSetupP2:
              'فیلدهای موجود در فرم می‌توانند شامل اطلاعات مختلفی مانند نام، شماره تلفن، ایمیل و سایر موارد باشند.',
            pageSetupP3:
              'در زیر هر فیلد نمایش‌داده‌شده، یک ورودی قرار دارد که باید توضیح مربوط به همان فیلد در آن نوشته شود.',
            fieldPurposeIntro: 'هدف از این توضیحات این است که مشخص شود:',
            fieldPurposeGoals: [
              'هر فیلد دقیقا چه مفهومی دارد',
              'چه اطلاعاتی باید در آن وارد شود',
              'کاربر نهایی چه مقداری باید برای آن فیلد ثبت کند',
            ],
            fieldPurposeClosing:
              'این توضیحات به آیدا کمک می‌کند تا منظور دقیق شما از هر متغیر را بهتر درک کند و اطلاعات صحیح‌تری از کاربران دریافت کند.',
            exampleTitle: 'مثال',
            exampleCompany:
              'اگر در فرم فیلدی با عنوان «اسم شرکت» وجود داشته باشد، می‌توانید در توضیحات آن بنویسید: نام شرکتی که کاربر در حال حاضر در آن مشغول به کار است وارد شود.',
            examplePhone:
              'یا برای فیلد «شماره تلفن» بنویسید: شماره تماس فعال و در دسترس کاربر به همراه کد کشور وارد شود.',
            displayConditionsTitle: 'تعیین شرایط دریافت اطلاعات',
            displayConditionsP1:
              'در انتهای صفحه، یک ورودی دیگر نیز قرار دارد که در آن باید مشخص کنید این فرم در چه شرایطی یا در چه زمانی باید از کاربر دریافت شود.',
            displayConditionsP2:
              'در این بخش می‌توانید سناریو یا موقعیتی که فرم باید نمایش داده شود را توضیح دهید.',
            displayExamplesTitle: 'مثال‌ها',
            displayExamples: [
              'زمانی که کاربر در حال خرید محصول است',
              'زمانی که کاربر به محصولی علاقه نشان داده است',
              'بعد از ثبت درخواست مشاوره',
              'هنگام ثبت‌نام یا ایجاد حساب کاربری',
            ],
            displayConditionsClosing:
              'این بخش کمک می‌کند سیستم تشخیص دهد فرم در چه موقعیتی باید به کاربر نمایش داده شود یا اطلاعات آن دریافت گردد.',
          },
        },
      },
    },
    // Channel
    channel: {
      title: 'تنظیمات کانال‌ها',
      description: 'در این بخش می‌توانید تنظیمات کانال‌های ارتباطی خود را مدیریت کنید',
      instagram: {
        title: 'اینستاگرام',
        description: 'اینستاگرام می‌تواند به عنوان کانال ارتباطی خود استفاده شود. برای اتصال به اینستاگرام، باید اتصال برقرار کنید.',
        enable: 'فعال کردن اینستاگرام',
        username: 'نام کاربری اینستاگرام',
        connected: 'اینستاگرام متصل است',
        register_Bot: 'ثبت نام در ربات تلگرام',
        Connent_help: 'با کلیک بر روی دکمه اتصل بر روی اینستاگرام می توانید اکانت خود را متصل کنید و از قابلیت های آیدا در اینستاگرام استفاده کنید.',
        notConnected: 'باتوجه به استقبال زیاد از کانال اینستاگرام، درخواست های جدید برای اتصال، در لیست انتظار قرار خواهد گرفت. لطفاً با استفاده از ربات تلگرام در لیست انتظار این کانال ثبت نام بفرمائید. بعد از ثبت نام در ربات تلگرام و هماهنگی با پشتیبان های آیدا بر روی دکمه آبی اتصال به اینستاگرام کلیک کنید',
        connect: 'اتصال به اینستاگرام',
        settings: 'تنظیمات اتصال به اینستاگرام',
        disconnect: 'قطع اتصال از اینستاگرام',
        connecting: 'در حال اتصال...',
        disconnecting: 'در حال قطع اتصال...',
        connectSuccess: 'اتصال به اینستاگرام با موفقیت برقرار شد',
        disconnectSuccess: 'اتصال از اینستاگرام با موفقیت قطع شد',
        connectError: 'خطا در اتصال به اینستاگرام',
        disconnectError: 'خطا در قطع اتصال از اینستاگرام',
        tokenExpires: 'انقضای توکن',
        tokenInvalid: 'توکن اینستاگرام نامعتبر است. لطفاً دوباره اتصال برقرار کنید.',
        usernameHelper: 'نام کاربری اینستاگرام کسب و کار شما که می‌خواهید با آن به پیام‌ها پاسخ دهید',
        password: 'رمز عبور اینستاگرام',
        passwordHelper: 'رمز عبور حساب اینستاگرام کسب و کار شما',
      },
      telegram: {
        title: 'تلگرام',
        description: 'تلگرام می‌تواند به عنوان کانال ارتباطی خود استفاده شود. برای اتصال به تلگرام، باید اتصال برقرار کنید.',
        descriptionHelper: 'توکن ربات تلگرام شما که می‌خواهید با آن به پیام‌ها پاسخ دهید را وارد کنید',
        enable: 'فعال کردن تلگرام',
        bot_token: 'توکن ربات تلگرام',
        bot_token_helper: 'توکن ربات تلگرام شما',
        connect: 'اتصال به تلگرام',
        settings: 'تنظیمات اتصال به تلگرام',
      },
      website: {
        title: 'وبسایت',
        description: 'وبسایت می‌تواند به عنوان کانال ارتباطی خود استفاده شود. برای اتصال به وبسایت، باید اتصال برقرار کنید.',
        descriptionHelper: 'شناسه چت باکس وبسایت شما که می‌خواهید با آن به پیام‌ها پاسخ دهید را وارد کنید',
        enable: 'فعال کردن وبسایت',
        chatbox_id: 'شناسه چت باکس وبسایت',
        website_address: 'آدرس وبسایت',
        invalidUrl: 'لطفا یک آدرس وبسایت معتبر وارد کنید (مثال: https://example.com)',
        connect: 'اتصال به وبسایت',
        settings: 'تنظیمات اتصال به وبسایت',
      },
      bale: {
        title: 'بله',
        description: 'بله می‌تواند به عنوان کانال ارتباطی خود استفاده شود. برای اتصال به بله، باید اتصال برقرار کنید.',
        descriptionHelper: 'توکن ربات بله شما که می‌خواهید با آن به پیام‌ها پاسخ دهید را وارد کنید',
        enable: 'فعال کردن بله',
        bot_token: 'توکن ربات بله',
        connect: 'اتصال به بله',
        settings: 'تنظیمات اتصال به بله',
      },
      kavenegar: {
        title: 'کاوه‌نگار',
        enable: 'فعال کردن کاوه‌نگار',
        api_key: 'کلید API کاوه‌نگار',
      },
      save: 'ذخیره',
      saving: 'در حال ذخیره...',
      close: 'بستن',
      active: 'پاسخگویی',
      inactive: 'عدم پاسخگویی',
      success: `اطلاعات کانال های شما با موفقیت ثبت شد`,
      error: {
        notFound: 'اطلاعات کانال‌ها یافت نشد. لطفا ابتدا فرآیند ثبت نام را تکمیل کنید.',
        incomplete: 'اطلاعات کانال‌ها ناقص است. لطفا تمام فیلدهای مورد نیاز را پر کنید.',
        saveError: 'خطا در ذخیره اطلاعات. لطفا دوباره تلاش کنید.',
        fetchError: 'خطا در دریافت اطلاعات کانال‌ها. لطفا دوباره تلاش کنید.',
      },
    },
    // Onboarding
    onboarding: {
      title: 'تکمیل پروفایل',
      steps: {
        personal: 'اطلاعات شخصی',
        business: 'اطلاعات کسب و کار',
        service: 'اطلاعات خدمات',
        channel: 'کانال‌های ارتباطی',
        subscription: 'اشتراک',
      },
      personal: {
        fullName: 'نام و نام خانوادگی',
        fullNameHelper: 'لطفا نام و نام خانوادگی خود را وارد کنید',
        phoneNumber: 'شماره تلفن',
        phoneNumberHelper: 'لطفا شماره تلفن خود را با کد کشور وارد کنید',
        position: 'سمت شغلی',
        positionHelper: 'لطفا سمت شغلی خود را وارد کنید',
        saveAndContinue: 'ذخیره و ادامه',
        saving: 'در حال ذخیره...',
        success_message: 'اطلاعات شما با موفقیت ثبت شد',
        email: 'ایمیل',
        emailHelper: 'لطفا ایمیل خود را وارد کنید',
        error: {
          saveError: 'خطا در ذخیره اطلاعات شخصی. لطفا دوباره تلاش کنید.'
        }
      },
      business: {
        businessName: 'نام کسب و کار',
        businessNameHelper: 'لطفا نام کسب و کار خود را وارد کنید',
        businessType: 'نوع کسب و کار',
        businessSize: 'اندازه کسب و کار',
        businessDescription: 'توضیحات کسب و کار',
        businessDescriptionHelper: 'لطفا توضیحات کامل کسب و کار خود را وارد کنید',
        address: 'آدرس',
        addressHelper: 'لطفا آدرس دقیق کسب و کار خود را وارد کنید',
        description: 'توضیحات',
        descriptionHelper: 'لطفا توضیحات اضافی کسب و کار خود را وارد کنید',
        saveAndContinue: 'ذخیره و ادامه',
        saving: 'در حال ذخیره...',
        save: 'ذخیره',
        success: 'اطلاعات کسب و کار شما با موفقیت ثبت شد',
        error: {
          notFound: 'اطلاعات کسب و کار یافت نشد. لطفا ابتدا فرآیند ثبت نام را تکمیل کنید.',
          incomplete: 'اطلاعات کسب و کار ناقص است. لطفا تمام فیلدهای مورد نیاز را پر کنید.',
          saveError: 'خطا در ذخیره اطلاعات کسب و کار. لطفا دوباره تلاش کنید.',
          fetchError: 'خطا در دریافت اطلاعات کسب و کار. لطفا دوباره تلاش کنید.',
        },
        types: {
          retail: 'خرده فروشی',
          service: 'خدمات',
          production: 'تولیدی',
          shopping: 'فروشگاهی',
          other: 'سایر',
        },
        sizes: {
          small: 'کوچک',
          medium: 'متوسط',
          large: 'بزرگ',
        },
      },
      service: {
        title: 'اطلاعات خدمات',
        description: 'لطفا اطلاعات خدمات خود را وارد کنید',
        serviceType: 'نوع خدمات',
        serviceTypeHelper: 'لطفا نوع خدمات خود را انتخاب کنید',
        serviceDescription: 'توضیحات خدمات',
        serviceDescriptionHelper: 'لطفا توضیحات کامل خدمات خود را وارد کنید',
        targetAudience: 'مخاطبان هدف',
        targetAudienceHelper: 'لطفا مخاطبان هدف خدمات خود را توضیح دهید',
        interactionStyle: 'سبک تعامل',
        interactionStyleHelper: 'لطفا سبک تعامل خود را انتخاب کنید',
        proactive: 'پیش‌گیرانه',
        reactive: 'واکنشی',
        save: 'ذخیره',
        saveAndContinue: 'ذخیره و ادامه',
        saving: 'در حال ذخیره...',
        success: 'اطلاعات با موفقیت بروزرسانی شد',
        error: {
          notFound: 'اطلاعات خدمات یافت نشد. لطفا ابتدا فرآیند ثبت نام را تکمیل کنید.',
          incomplete: 'اطلاعات خدمات ناقص است. لطفا تمام فیلدهای مورد نیاز را پر کنید.',
          saveError: 'خطا در ذخیره اطلاعات. لطفا دوباره تلاش کنید.',
          fetchError: 'خطا در دریافت اطلاعات خدمات. لطفا دوباره تلاش کنید.',
          sessionExpired: 'جلسه شما منقضی شده است. لطفاً دوباره وارد شوید.',
        },
        types: {
          consultation: 'مشاوره',
          training: 'آموزش',
          service: 'خدمات',
          other: 'سایر',
        },
        interactionStyles: {
          proactive: 'پیش‌گیرانه',
          reactive: 'واکنشی',
        },
      },
      channel: {
        instagram: 'اینستاگرام',
        enableInstagram: 'فعال کردن اینستاگرام',
        instagramUsername: 'نام کاربری اینستاگرام',
        instagramUsernameHelper: 'نام کاربری اینستاگرام کسب و کار شما که می‌خواهید با آن به پیام‌ها پاسخ دهید',
        instagramPassword: 'رمز عبور اینستاگرام',
        instagramPasswordHelper: 'رمز عبور حساب اینستاگرام کسب و کار شما',
        telegram: 'تلگرام',
        enableTelegram: 'فعال کردن تلگرام',
        telegramBotToken: 'توکن ربات تلگرام',
        telegramBotTokenHelper: 'توکن ربات تلگرام شما',
        website: {
          title: 'وبسایت',
          enable: 'فعال کردن وبسایت',
          chatbox_id: 'شناسه چت باکس وبسایت',
        },
        bale: {
          title: 'بله',
          enable: 'فعال کردن بله',
          bot_token: 'توکن ربات بله',
        },
        kavenegar: {
          title: 'کاوه‌نگار',
          enable: 'فعال کردن کاوه‌نگار',
          api_key: 'کلید API کاوه‌نگار',
        },
        saveAndContinue: 'ذخیره و ادامه',
        saving: 'در حال ذخیره...',
      },
      subscription: {
        none: 'بدون اشتراک',
        plan: 'طرح',
        duration: 'مدت زمان',
        quarterly: 'سه ماهه',
        semiannual: 'شش ماهه',
        annual: 'سالانه',
        intern: 'کارآموز',
        expert: 'کارشناس',
        master: 'ارشد',
        business: 'بیزنس',
        select: 'انتخاب',
        initiatePayment: 'شروع پرداخت',
        verifying: 'در حال تایید...',
        plans_info: {
          seller: {
            intern: {
              title: "کارآموز",
              price: {
                QUARTERLY: '3 میلیون تومان',
                SEMIANNUAL: '6 میلیون تومان',
                ANNUAL: '10 میلیون تومان',
              },
              features: [
                '1 کانال فعال',
                'داشتن 1 دوست فعال آیدا',
                '5 پاسخگویی همزمان',
                'سرعت معمولی در پاسخگویی',
                'حضور ذهن معمولی',
                '50 پیام مجاز در ماه',
                '24 ساعت زمان ذخیره سازی گفتگو',
                'پشتیبانی از طریق تیکت',
              ]
            },
            expert: {
              title: "کارشناس",
              price: {
                QUARTERLY: '6 میلیون تومان',
                SEMIANNUAL: '12 میلیون تومان',
                ANNUAL: '20 میلیون تومان',
              },
              features: [
                '3 کانال فعال',
                'داشتن 2 دوست فعال آیدا',
                '20 پاسخگویی همزمان',
                'سرعت خوب در پاسخگویی',
                'حضور ذهن خوب',
                '5000 پیام مجاز در ماه',
                '30 روز زمان ذخیره سازی گفتگو',
                'پشتیبانی تیکت و تماس پشتیبانی با شما',
              ]
            },
            master: {
              title: "کارشناس ارشد",
              price: {
                QUARTERLY: '15 میلیون تومان',
                SEMIANNUAL: '30 میلیون تومان',
                ANNUAL: '50 میلیون تومان',
              },
              features: [
                '10 کانال فعال',
                'داشتن 10 دوست فعال آیدا',
                '100 پاسخگویی همزمان',
                'سرعت عالی در پاسخگویی',
                'حضور ذهن عالی',
                '10000 پیام مجاز در ماه',
                '6 ماه زمان ذخیره سازی گفتگو',
                'پشتیبانی تیکت و تماس پشتیبانی با شما و کارشناس مشتری اختصاصی',
              ]
            }
          },
        },
        durations: {
          QUARTERLY: 'سه ماهه',
          SEMIANNUAL: 'شش ماهه',
          ANNUAL: 'سالانه',
        },
        types: {
          seller: 'فروشنده',
          assistant: 'دستیار',
        },
        messeges: {
          success: {
            intern: 'اشتراک کارآموز با موفقیت فعال شد',
            expert: 'اشتراک کارشناس با موفقیت فعال شد',
            master: 'اشتراک ارشد با موفقیت فعال شد',
          },
          error: 'خطا در فعال سازی اشتراک'
        },
        payment: {
          processing: 'در حال پردازش درخواست...',
          active: 'اشتراک 14 روز کارآموز با موفقیت فعال شد',
          active_intern: 'فعال‌سازی 14 روز کارآموز',
          button: 'پرداخت و فعال‌سازی',
        },
        title: {
          selectPlan: 'انتخاب پلن اشتراک',
          selectType: 'نوع آیدا',
          free: 'رایگان',
          cash_type: 'تومان',
          intern_description: '14 روز کارآموز',
          semiannual_description: 'شش ماهانه (10% تخفیف)',
          quarterly_description: 'سه ماهه',
          annual_description: 'سالانه (۲۰٪ تخفیف)',
          button: 'انتخاب',
          duration_title_select: 'دوره اشتراک',
          intern_description_select: 'این پلن 14 روز اعتبار دارد (فقط یک بار قابل فعال سازی است)',
          semiannual_description_select: ' /شش ماهانه (10% تخفیف)',
          quarterly_description_select: ' /سه ماهه',
          annual_description_select: ' /سالانه (۲۰٪ تخفیف)',
          temp1: 'اشتراک',
          mamad: ' / 14 روز کارآموز',
        },
        coupon: {
          coupon_code: 'کد تخفیف',
          coupon_code_helper: 'کد تخفیف خود را وارد کنید',
          discount_factor: 'میزان تخفیف',
          discount_factor_helper: 'برای شما فعال شد.',
          valid_coupon: 'کد تخفیف معتبر است',
          invalid_coupon: 'کد تخفیف معتبر نیست',
          error_checking_coupon: 'خطا در بررسی کد تخفیف',
          please_enter: 'لطفا کد تخفیف را وارد کنید.'
        }
      },
    },
    // Automation
    automation: {
      table:{
        direct: "دایرکت",
        comment: "کامنت",
        both: "دایرکت و کامنت",
        equals: "برابر با",
        contains: "شامل",
        id: "شناسه",
        channelType: "نوع کانال",
        conditionType: "نوع شرط",
        triggerValue: "مقدار محرک",
        responseMessage: "پیام پاسخ",
        status: "وضعیت",
        createdAt: "تاریخ ایجاد",
        operations: "عملیات",
        active: "وضعیت فعال/غیرفعال",
      },
      automation_bot: {
        error: {
          sessionExpired: "جلسه کاری شما منقضی شداست دوباره وارد شوید.",
          deleteError: "خطا در حذف دستور",
          pick_channel: "لطفا حداقل یک نوع کانال را انتخاب کنید",
          enter_trigger: "لطفا کلمه یا جمله محرک را وارد کنید",
          enter_response: "لطفا پیام پاسخ را وارد کنید",
          toggleActive: "خطا در تغییر وضعیت",
        },
        success: {
          delete: "دستور با موفقیت حذف شد",
          add: "دستور با موفقیت اضافه شد",
          update: "دستور با موفقیت ویرایش شد",
          toggleActive: "وضعیت با موفقیت تغییر کرد",
        },
        edit: {
          title: "ویرایش دستور",
          update: "بروزرسانی",
        },
        add: {
          title: "افزودن دستور",
          success: "دستور با موفقیت اضافه شد",
          error: "خطا در اضافه کردن دستور",
          cancel: "انصراف",
          type: "نوع دستور",
          content: "محتوا",
          url: "لینک",
          uploadCsv: "بارگذاری CSV",
          uploadExcel: "بارگذاری Excel",
          uploadPdf: "بارگذاری PDF",
          uploadText: "بارگذاری متن",
          selectedFile: "فایل انتخاب شده: {fileName}",
          deletedAt: "زمان حذف",
          save: "ذخیره",
          details: "جزئیات دستور",
          if_user_in: "اگر کاربر شما در",
          comment: "کامنت (پست و لایو)",
          trigger: "کلمه یا جمله ای",
          condition: "حالت شرط",
          value: "مقدار",
          send_message: "را ارسال کند پیام زیر برایش ارسال شود",
          response_message: "پیام پاسخ",
          create: "ایجاد",
          active: "فعال",
          inactive: "غیرفعال",
          button_text: "متن دکمه",
          has_button_in_response: "دکمه در جواب آیدا",
          button_url: "آدرس دکمه",
        },
        flush: {
          deleteAll: "پاک کردن همه دستورات",
          success: "دستورات با موفقیت پاک شدند",
          confirm: "تایید پاک کردن همه دستورات",
          confirmDescription: "آیا می خواهید همه دستورات را پاک کنید؟",
          delete: "پاک کردن",
        },
        list: {
          title: "دستورات",
          empty: "دستوری یافت نشد",
          id: "شناسه",
          channelType: "نوع کانال",
          conditionType: "نوع شرط",
          triggerValue: "مقدار محرک",
          responseMessage: "پیام پاسخ",
          status: "وضعیت",
          createdAt: "تاریخ ایجاد",
          updatedAt: "تاریخ بروزرسانی",
          actions: "عملیات",
          showLess: "نمایش کمتر",
          showMore: "نمایش بیشتر",
          confirmDeleteTitle: "تایید حذف",
          confirmDelete: "آیا می خواهید این دستور را حذف کنید؟",
          delete: "حذف",
          active: "فعال",
          inactive: "غیرفعال",
          direct: "دایرکت",
          comment: "کامنت",
          both: "دایرکت و کامنت",
          equals: "برابر با",
          contains: "شامل",
        },
        preview: {
          title: "آیدا",
        },
      },
    },
    // Common
    common: {
      loading: 'در حال بارگذاری...',
      error: 'خطا',
      success: 'موفق',
      save: 'ذخیره',
      cancel: 'انصراف',
      back: 'بازگشت',
      next: 'بعدی',
      submit: 'ارسال',
      delete: 'حذف',
      edit: 'ویرایش',
      search: 'جستجو',
      filter: 'فیلتر',
      sort: 'مرتب‌سازی',
      refresh: 'بروزرسانی',
      previous: 'قبلی',
      appName: 'آیدا',
      rowsPerPage: 'تعداد سطر در صفحه',
    },
    // Business
    business: {
      title: "اطلاعات کسب و کار",
      pageDescription: "لطفا اطلاعات کسب و کار خود را وارد کنید",
      additionalDescription: "این اطلاعات برای بهبود خدمات ما استفاده خواهد شد",
      success: "اطلاعات کسب و کار شما با موفقیت ثبت شد",
      businessName: 'نام کسب و کار',
      businessNameHelper: 'لطفا نام کسب و کار خود را وارد کنید',
      businessType: 'نوع کسب و کار',
      businessTypeHelper: 'لطفا نوع کسب و کار خود را وارد کنید',
      businessSize: 'اندازه کسب و کار',
      businessSizeHelper: 'لطفا اندازه کسب و کار خود را انتخاب کنید',
      businessDescription: 'توضیحات کسب و کار',
      businessDescriptionHelper: 'لطفا توضیحات کامل کسب و کار خود را وارد کنید',
      address: 'آدرس',
      addressHelper: 'لطفا آدرس دقیق کسب و کار خود را وارد کنید',
      description: 'توضیحات',
      descriptionHelper: 'لطفا توضیحات اضافی کسب و کار خود را وارد کنید',
      save: 'ذخیره',
      saving: 'در حال ذخیره...',
      edit_modal_button: 'ویرایش اطلاعات',
      edit_modal_title: 'ویرایش اطلاعات کسب و کار',
      cancel: 'لغو',
      save_modal: 'ذخیره',
      sizes: {
        small: 'کوچک',
        medium: 'متوسط',
        large: 'بزرگ'
      },
      error: {
        notFound: 'اطلاعات کسب و کار یافت نشد. لطفا ابتدا فرآیند ثبت نام را تکمیل کنید.',
        incomplete: 'اطلاعات کسب و کار ناقص است. لطفا تمام فیلدهای مورد نیاز را پر کنید.',
        saveError: 'خطا در ذخیره اطلاعات کسب و کار. لطفا دوباره تلاش کنید.',
        fetchError: 'خطا در دریافت اطلاعات کسب و کار. لطفا دوباره تلاش کنید.',
        sessionExpired: 'جلسه شما منقضی شده است. لطفاً دوباره وارد شوید.',
        forbidden: 'شما دسترسی به تغییر دادن این بخش ندارید.',
        business_name_error: "حداقل تعداد کاراکتر های اسم باید 2 باشد",
        business_des_error: "حداقل تعداد کاراکتر های توضیحات بیزنس باید 5 باشد",
        address_error: "حداقل تعداد کاراکتر های آدرس باید 6 باشد"
      }
    },
    // Service
    service: {
      title: 'اطلاعات خدمات',
      description: 'لطفا اطلاعات خدمات خود را وارد کنید',
      serviceType: 'نوع خدمات',
      serviceTypeHelper: 'لطفا نوع خدمات خود را انتخاب کنید',
      serviceDescription: 'توضیحات خدمات',
      serviceDescriptionHelper: 'لطفا توضیحات کامل خدمات خود را وارد کنید',
      targetAudience: 'مخاطبان هدف',
      targetAudienceHelper: 'لطفا مخاطبان هدف خدمات خود را توضیح دهید',
      interactionStyle: 'سبک تعامل',
      interactionStyleHelper: 'لطفا سبک تعامل خود را انتخاب کنید',
      proactive: 'پیش‌گیرانه',
      reactive: 'واکنشی',
      save: 'ذخیره',
      saveAndContinue: 'ذخیره و ادامه',
      saving: 'در حال ذخیره...',
      success: `اطلاعات خدمات شما با موفقیت ثبت شد`,
      error: {
        notFound: 'اطلاعات خدمات یافت نشد. لطفا ابتدا فرآیند ثبت نام را تکمیل کنید.',
        incomplete: 'اطلاعات خدمات ناقص است. لطفا تمام فیلدهای مورد نیاز را پر کنید.',
        saveError: 'خطا در ذخیره اطلاعات. لطفا دوباره تلاش کنید.',
        fetchError: 'خطا در دریافت اطلاعات خدمات. لطفا دوباره تلاش کنید.',
        sessionExpired: 'جلسه شما منقضی شده است. لطفاً دوباره وارد شوید.',
      },
      types: {
        consultation: 'مشاوره',
        training: 'آموزش',
        service: 'خدمات',
        other: 'سایر',
      },
      interactionStyles: {
        proactive: 'پیش‌گیرانه',
        reactive: 'واکنشی',
      },
    },
    // Chatbox
    chatbox: {
      title: 'چت باکس',
      tabs: {
        chatbox: 'محیط تست',
        documentation: 'مستندات',
        chatbox_properties: 'تنظیمات',
      },
      settings: {
        title: 'تنظیمات چت باکس',
        position: 'موقعیت چت باکس',
        defaultState: 'نمایش پیش فرض',
        preview: 'پیش نمایش چت باکس',
        right: 'راست',
        left: 'چپ',
        closed: 'بسته',
        open: 'باز',
        timeOpen: {
          title: 'زمان باز شدن به صورت خودکار',
          on: 'روشن',
          off: 'خاموش',
          unit: 'ثانیه',
        },
        processing: {
          title: 'وضعیت فکری آیدا در زمان پاسخ',
          on: 'روشن',
          off: 'خاموش',
        },
      },
      preview: {
        title: 'پیش نمایش چت باکس',
        description: 'این پیش نمایش چت باکس آیدا است.',
      },
      message: {
        placeholder: 'پیام خود را بنویسید...',
        send: 'ارسال',
        copy: 'کپی به کلیپ‌بورد',
        copied: 'کپی شد!',
        emptyMessage: 'لطفاً پیام خود را وارد کنید.',
        waitForResponse: 'لطفاً تا دریافت پاسخ قبلی صبر کنید.',
        noChatboxId: 'شناسه چت باکس یافت نشد.',
        websiteAddressNotConfigured: 'در تنظیمات کانال‌ها آدرس مقصد وبسایت را تنظیم کنید.',
      },
      guide: {
        title: 'راهنمای استفاده',
        description: 'این چت باکس نمونه برای تست و آشنایی با قابلیت‌های چت باکس آیدا است.',
        documentation: 'برای استفاده در وبسایت یا اپلیکیشن خود، به مستندات مراجعه کنید.',
      },
      documentation: {
        title: 'مستندات',
        description: 'برای استفاده از چت باکس آیدا در وبسایت یا اپلیکیشن خود، از کد زیر استفاده کنید:',
        example: {
          title: 'مثال',
          description: 'این یک مثال ساده از نحوه استفاده از API چت باکس است.',
        },
        integration: {
          title: 'ادغام وبسایت',
          description: 'برای اضافه کردن چت باکس آیدا به هر وبسایتی، کافی است تگ اسکریپت زیر را قبل از تگ بسته </body> قرار دهید:',
          prerequisites: {
            title: 'پیش‌نیازها',
            description: 'قبل از استفاده از چت باکس، مطمئن شوید که:',
            list: [
              'آدرس وبسایت خود را در آیدا ← کانال‌ها ← وبسایت تنظیم کرده‌اید',
              'کانال وبسایت را فعال کرده‌اید',
              'شناسه چت باکس خود را از صفحه کانال‌ها کپی کرده‌اید (در بالا نمایش داده شده)'
            ]
          },
          wordpress: {
            title: 'ادغام وردپرس',
            description: 'برای اضافه کردن چت باکس به وبسایت وردپرس خود، چندین گزینه دارید:',
            method1: {
              title: 'روش 1: استفاده از سفارشی‌ساز وردپرس',
              steps: [
                'به قسمت ظاهر ← سفارشی‌سازی در پنل مدیریت وردپرس بروید',
                'روی CSS اضافی یا گزینه‌های قالب کلیک کنید',
                'تگ اسکریپت را به بخش فوتر اضافه کنید'
              ]
            },
            method2: {
              title: 'روش 2: استفاده از افزونه',
              steps: [
                'افزونه‌ای مانند "Insert Headers and Footers" یا "Code Snippets" نصب کنید',
                'به تنظیمات افزونه بروید',
                'کد اسکریپت را در بخش "فوتر" قرار دهید',
                'تغییرات را ذخیره کنید'
              ]
            },
            method3: {
              title: 'روش 3: ویرایش فایل‌های قالب',
              steps: [
                'به قسمت ظاهر ← ویرایشگر قالب بروید',
                'فایل footer.php را از لیست فایل‌ها انتخاب کنید',
                'تگ اسکریپت را دقیقاً قبل از تگ بسته </body> اضافه کنید',
                'روی به‌روزرسانی فایل کلیک کنید'
              ]
            }
          },
          testing: {
            title: 'تست',
            description: 'پس از اضافه کردن اسکریپت به وبسایت خود:',
            steps: [
              'وبسایت خود را در یک تب جدید مرورگر بازدید کنید',
              'به دنبال ویجت چت باکس آیدا بگردید (معمولاً در گوشه پایین راست ظاهر می‌شود)',
              'ارسال پیام را تست کنید تا مطمئن شوید درست کار می‌کند'
            ]
          }
        }
      },
      faq: {
        title: 'سوالات متداول',
        description: 'در این بخش می توانید سوالات متداول را قرار دهید که در بخش ابتدایی چت باکس آیدا نمایش داده شود.',
        description2: '!!! پس از تغییر حتما کد اسکریپت را دوباره در سایت خود قرار دهید.',
        addQuestion: 'افزودن سوال',
        question: 'سوال',
        placeholderQ: 'مثلا: قیمت اشتراک چقدر است؟',
        delete: 'حذف',
      },
      didarForm: {
        title: 'فرم دیدار',
        urlPlaceholder: 'لینک URL دیدار',
        confirmUrl: 'تایید لینک',
        fieldTitle: '{title}',
        fieldLegend: 'توضیحات {title}',
        fieldPlaceholder: 'توضیحات که در رابطه با {title} میخواهید از کاربر دریافت کنید را بنویسید',
        confirm: 'تایید',
        invalidUrl: 'لینک فرم دیدار معتبر نیست. لطفاً لینک کامل یا شناسه فرم را وارد کنید.',
        loadError: 'دریافت اطلاعات فرم با خطا مواجه شد. لطفاً دوباره تلاش کنید.',
      },
    },
    // Payments
    payments: {
      title: 'پرداخت‌ها',
      description: 'در این بخش می‌توانید تاریخچه پرداخت‌های خود را مشاهده کنید',
      date: 'تاریخ',
      amount: 'مبلغ',
      status: 'وضعیت',
      type: 'نوع',
      plan: 'پلن',
      cardNumber: 'شماره کارت',
      trackingCode: 'کد پیگیری',
      invoice: 'صورتحساب',
      success: 'موفق',
      failed: 'ناموفق',
      pending: 'در انتظار',
      subscription: 'اشتراک',
      renewal: 'تمدید',
      oneTime: 'یک‌باره',
      noPayments: 'پرداختی یافت نشد',
      rowsPerPage: 'تعداد در هر صفحه',
      fromDate: 'از تاریخ',
      toDate: 'تا تاریخ',
      paymentId: 'شناسه پرداخت',
      cash_type: ' ریال',
      error: {
        fetchError: 'خطا در دریافت اطلاعات پرداخت. لطفا دوباره تلاش کنید.',
        sessionExpired: 'جلسه شما منقضی شده است. لطفاً دوباره وارد شوید.',
      },
    },
    // Profile
    profile: {
      title: 'پروفایل',
      description: 'در این بخش می‌توانید اطلاعات شخصی خود را مشاهده و ویرایش کنید',
      fullName: 'نام و نام خانوادگی',
      fullNameHelper: 'لطفا نام و نام خانوادگی خود را وارد کنید',
      phoneNumber: 'شماره تلفن',
      phoneNumberHelper: 'لطفا شماره تلفن خود را با کد کشور وارد کنید',
      position: 'سمت شغلی',
      positionHelper: 'لطفا سمت شغلی خود را وارد کنید',
      email: 'ایمیل',
      emailHelper:'لطفا ایمیل خود را وارد کنید',
      save: 'ذخیره',
      saving: 'در حال ذخیره...',
      success: 'اطلاعات پروفایل شما با موفقیت ثبت شد',
      edit_profile: 'ویرایش پروفایل',
      edit_modal_title: 'ویرایش اطلاعات پروفایل',
      cancel: 'لغو',
      save_modal_profile: 'ذخیره',
      error: {
        phone_number_invalid: 'شماره تلفن نامعتبر است.',
        notFound: 'اطلاعات پروفایل یافت نشد. لطفا ابتدا فرآیند ثبت نام را تکمیل کنید.',
        incomplete: 'اطلاعات پروفایل ناقص است. لطفا تمام فیلدهای مورد نیاز را پر کنید.',
        saveError: 'خطا در ذخیره اطلاعات. لطفا دوباره تلاش کنید.',
        fetchError: 'خطا در دریافت اطلاعات پروفایل. لطفا دوباره تلاش کنید.',
        sessionExpired: 'جلسه شما منقضی شده است. لطفاً دوباره وارد شوید.',
        phone_pattern_error: "شماره همراه خود را اصلاح کنید",
        string_pattern_error: "نام و نام خانوادگی و سمت شغلی باید بالای 2 کاراکتر داشته باشند.",
        email_error_already_register: "ایمیل وارد شده را نمی توانید انتخاب کنید",
        phone_error_already_register: "شماره تلفن وارد شده را نمی توانید انتخاب کنید",
      },
    },
    // Conversations
    conversations: {
      title: 'مکالمات',
      description: 'در این بخش می‌توانید مکالمات خود را مشاهده و مدیریت کنید',
      id: 'شناسه',
      username: 'نام کاربری',
      channel: 'کانال',
      inputMessage: 'پیام ورودی',
      outputMessage: 'پیام خروجی',
      inputTokens: 'توکن‌های ورودی',
      outputTokens: 'توکن‌های خروجی',
      model: 'مدل',
      date: 'تاریخ',
      status: 'وضعیت',
      lastMessage: 'آخرین پیام',
      active: 'فعال',
      closed: 'بسته شده',
      noConversations: 'هیچ مکالمه‌ای یافت نشد',
      filterByUsername: 'فیلتر بر اساس نام کاربری',
      startDate: 'تاریخ شروع',
      endDate: 'تاریخ پایان',
      showing: 'در حال نمایش {start}-{end} از {total}',
      channels: 'کانال‌ها',
      users: 'کاربران',
      messages: 'پیام',
      clickToViewUsers: 'برای مشاهده کاربران کلیک کنید',
      noChannels: 'هیچ کانالی یافت نشد',
      noUsers: 'هیچ کاربری یافت نشد',
      noMessages: 'هیچ پیامی یافت نشد',
      moreUsers: 'نمایش افراد بیشتر',
      loadMoreMessages: 'نمایش پیام های جدیدتر',
      loadPreviousMessages: 'نمایش پیام‌های قبلی',
      thread: 'رشته',
      emptyState: {
        title: 'فعال کردن آیدا خود به کانال ها و پاسخگویی به مشتریان شما',
        connectInstagram: 'متصل شدن به اینستاگرام',
        connectTelegram: 'متصل شدن به تلگرام',
        connectWebsite: 'متصل شدن به وبسایت',
        connectBale: 'متصل شدن به بله',
        guideLink: 'آموزش صفحه گفتگو ها',
      },
      guide: {
        title: 'راهنمای صفحه گفتگوها',
        intro: 'در این صفحه می‌توانید تمام گفتگوهای انجام‌شده بین آیدا و مشتریان خود را مشاهده و بررسی کنید.',
        structureIntro: 'ساختار صفحه از یک جدول سه ستونه تشکیل شده است که از راست به چپ شامل بخش‌های زیر می‌شود:',
        channelsTitle: 'کانال‌ها',
        channelsDescription: 'در ستون اول، کانال‌های ارتباطی آیدا نمایش داده می‌شوند:',
        channelsHint: 'با انتخاب هر کانال، لیست افرادی که از طریق آن بستر با آیدا گفتگو کرده‌اند در ستون دوم نمایش داده می‌شود.',
        usersTitle: 'کاربران',
        usersDescription: 'در ستون دوم، کاربران و مشتریانی که در کانال انتخاب‌شده با آیدا در ارتباط بوده‌اند نمایش داده می‌شوند.',
        usersHint: 'با کلیک روی هر کاربر، تاریخچه کامل گفتگوهای او با آیدا قابل مشاهده خواهد بود.',
        messagesTitle: 'پیام‌ها',
        messagesDescription: 'در ستون سوم، متن کامل مکالمات بین مشتری و آیدا نمایش داده می‌شود.',
        messagesHint: 'در این بخش می‌توانید پیام‌های ارسال‌شده، پاسخ‌های آیدا و روند کامل گفتگو را بررسی کنید.',
        purposeIntro: 'هدف این صفحه فقط مشاهده مکالمات نیست؛ بلکه ابزاری برای ارزیابی و بهبود عملکرد آیدا است. با بررسی پاسخ‌های آیدا می‌توانید:',
        purposeItems: [
          'نقاط قوت و ضعف پاسخ‌ها را شناسایی کنید.',
          'دانش آیدا را تکمیل و به‌روزرسانی کنید.',
          'رفتار و تنظیمات پاسخ‌گویی را بهینه کنید.',
          'دستورات و کمپین‌های جدید تعریف کنید.',
          'کیفیت ارتباط با مشتریان را افزایش دهید.',
        ],
        closing: 'هرچه مکالمات بیشتری را بررسی و تحلیل کنید، آیدا شناخت دقیق‌تری از کسب‌وکار شما پیدا می‌کند و می‌تواند پاسخ‌های بهتر و مؤثرتری به مشتریان ارائه دهد.',
      },
      error: {
        fetchError: 'خطا در دریافت اطلاعات مکالمات. لطفا دوباره تلاش کنید.',
        fetchChannelsError: 'خطا در دریافت لیست کانال‌ها. لطفا دوباره تلاش کنید.',
        fetchUsersError: 'خطا در دریافت لیست کاربران. لطفا دوباره تلاش کنید.',
        fetchMessagesError: 'خطا در دریافت پیام‌ها. لطفا دوباره تلاش کنید.',
        sessionExpired: 'جلسه شما منقضی شده است. لطفاً دوباره وارد شوید.',
      },
    },
    // Knowledge
    knowledge: {
      add: {
        title: 'افزودن دانش',
        description: 'در این بخش می‌توانید دانش جدید به آیدا اضافه کنید',
        type: 'نوع دانش',
        content: 'محتوا',
        uploadPdf: 'آپلود فایل PDF',
        uploadExcel: 'آپلود فایل اکسل',
        uploadCsv: 'آپلود فایل CSV',
        url: 'آدرس مقاله',
        deletedAt: 'تاریخ انقضا (اختیاری)',
        selectedFile: 'فایل انتخاب شده',
        save: 'ذخیره',
        saving: 'در حال ذخیره...',
        success: `دانش با موفقیت اضافه شد`,
        error: {
          incomplete: 'اطلاعات ناقص است. لطفا تمام فیلدهای مورد نیاز را پر کنید.',
          saveError: 'خطا در ذخیره دانش. لطفا دوباره تلاش کنید.',
        },
        instructions: {
          product: 'فایل اکسل باید از DidarCRM خروجی گرفته شده باشد و باید شامل ستون‌های زیر باشد: عنوان محصول، واحد محصول، قیمت هر واحد محصول، واحد ارزی محصول، گروه محصول، عنوان برای فاکتور محصول',
          faq: 'فایل CSV باید شامل ستون‌های question و answer باشد.',
          contact: 'فایل CSV باید شامل ستون‌های name، role، email و description باشد.',
          kb_article: 'آدرس یک مقاله یا صفحه وب را وارد کنید تا محتوای آن استخراج شود.',
          text: 'متن دلخواه خود را وارد کنید تا به دانش افزوده شود.',
          pdf: 'یک فایل PDF بارگذاری کنید تا محتوای آن به دانش افزوده شود.',
        },
        cancel: 'انصراف از افزودن دانش',
      },
      stats: {
        title: 'آمار دانش',
        description: 'در این بخش می‌توانید آمار دانش آیدا را مشاهده کنید',
        total: 'کل دانش',
        totalEntries: 'تعداد کل ورودی‌ها',
        totalCharacters: 'تعداد کل کاراکترها',
        estimatedTokens: 'تخمین تعداد توکن‌ها',
        estimatedCost: 'تخمین هزینه',
        lastUpdated: 'آخرین بروزرسانی',
        notUpdated: 'هنوز بروزرسانی نشده',
        error: {
          fetchError: 'خطا در دریافت آمار دانش. لطفا دوباره تلاش کنید.',
          sessionExpired: 'جلسه شما منقضی شده است. لطفاً دوباره وارد شوید.',
        },
      },
      flush: {
        title: 'پاکسازی دانش',
        description: 'در این بخش می‌توانید دانش آیدا را پاکسازی کنید',
        confirm: 'آیا از پاکسازی دانش اطمینان دارید؟',
        deleteAll: 'حذف تمام دانش',
        success: `همه دانش ها با موفقیت پاک شد`,
        error: {
          flushError: 'خطا در پاکسازی دانش. لطفا دوباره تلاش کنید.',
        },
        confirmDescription: 'همه دانش ها حذف خواهند شد و دیگر قابل بازیابی نخواهند بود.',
        delete: 'حذف همه دانش ها',
      },
      list: {
        title: 'لیست دانش',
        id: 'شناسه',
        sourceType: 'نوع منبع',
        sourceName: 'نام منبع',
        content: 'محتوا',
        createdAt: 'تاریخ ایجاد',
        updatedAt: 'تاریخ بروزرسانی',
        actions: 'عملیات',
        empty: 'دانشی یافت نشد.',
        confirmDeleteTitle: 'تایید حذف',
        confirmDelete: 'آیا از حذف این دانش اطمینان دارید؟',
        delete: 'حذف',
        showMore: 'نمایش بیشتر',
        showLess: 'نمایش کمتر',
        upgradeMessage: 'سیستم دانش در حال ارتقا است. این فرآیند تا دوشنبه، 10 آذر 1404، ادامه خواهد داشت.',
        success: {
          delete: 'دانش با موفقیت حذف شد.',
        },
        error: {
          fetchError: 'خطا در دریافت لیست دانش.',
          deleteError: 'خطا در حذف دانش.',
          sessionExpired: 'جلسه شما منقضی شده است. لطفاً دوباره وارد شوید.',
        },
      },
      edit: {
        title: 'ویرایش دانش',
        update: 'بروزرسانی',
        success: 'دانش با موفقیت بروزرسانی شد',
        error: {
          fetchError: 'خطا در دریافت دانش.',
          updateError: 'خطا در بروزرسانی دانش.',
        },
      }
    },
    // Behavior
    behavior: {
      title: 'رفتار آیدا',
      description: 'در این بخش می‌توانید رفتار و نحوه پاسخگویی آیدا را تنظیم کنید',
      save: 'ذخیره',
      saving: 'در حال ذخیره...',
      success: 'تنظیمات رفتار با موفقیت بروزرسانی شد',
      systemPrompt: {
        success: 'شناخت آیدا با موفقیت به‌روزرسانی شد',
        error: 'خطا در به‌روزرسانی شناخت آیدا',
        open: 'شناخت آیدا باز شد',
        close: 'شناخت آیدا قفل شد',
        errorlock: 'خطا در تغییر وضعیت شناخت آیدا',
        editTitle: 'ویرایش شناخت آیدا از شما',
        placeholder: 'شناخت آیدا از شما را اینجا وارد کنید...',
        cancel: 'انصراف',
        save: 'ذخیره',
        title: 'شناخت آیدا از شما',
      },
      error: {
        fetchError: 'خطا در دریافت تنظیمات رفتار. لطفا دوباره تلاش کنید.',
        Aida_notFound: 'آیدا فعالی ندارید.',
        sessionExpired: 'جلسه شما منقضی شده است. لطفاً دوباره وارد شوید.',
        saveError: 'خطا در ذخیره تنظیمات رفتار. لطفا دوباره تلاش کنید.',
      },
      conversionStyle: {
        title: 'سبک مکالمه',
        description: 'این تنظیم تعیین می‌کند که آیدا چگونه با کاربران تعامل کند',
        proactive: {
          title: 'پیش‌گیرانه',
          description: 'آیدا سوالات می‌پرسد تا مکالمه ادامه یابد و متوقف نشود',
        },
        reactive: {
          title: 'واکنشی',
          description: 'آیدا فقط به سوالات کاربران پاسخ می‌دهد و سوال نمی‌پرسد',
        },
        rejex: {
          title: 'حالت های پاسخگویی',
          description: 'این تنظیم یک سری قانون ها برای پاسخگویی آیدا تعیین می‌کند',
          noFilters: 'در حال حاضر هیچ فیلتری موجود نیست',
          active: 'فعال',
          inactive: 'غیرفعال',
        },
      },
      lengthOfResponse: {
        title: 'طول پاسخ های آیدا',
        description: 'در این بخش می‌توانید طول پاسخ های آیدا را تنظیم کنید',
        long: {
          title: 'طول پاسخ ها زیاد',
          description: 'آیدا پاسخ های طولانی و تفصیلی ارائه می‌دهد',
        },
        medium: {
          title: 'طول پاسخ ها متوسط',
          description: 'آیدا پاسخ های متعادل و متوسط ارائه می‌دهد',
        },
        short: {
          title: 'طول پاسخ ها کوتاه',
          description: 'آیدا پاسخ های کوتاه و مختصر ارائه می‌دهد',
        },
      },
      salesRole: {
        title: 'نقش فروش',
        description: 'تعیین می‌کند که آیدا برای چه کسی استفاده می‌شود',
        representative: {
          title: 'نماینده فروش',
          description: 'آیدا توسط خریداران استفاده می‌شود که می‌خواهند چیزی از شما بخرند',
        },
        assistant: {
          title: 'دستیار فروش',
          description: 'آیدا توسط فروشندگان شما به عنوان دستیار برای غنی‌سازی فرآیند فروش استفاده می‌شود',
        },
      },
      salesMethodology: {
        title: 'روش‌شناسی فروش',
        description: 'انتخاب روش فروش مناسب برای کسب و کار شما',
        labels: {
          goal: 'هدف:',
          tone: 'تن صدا:',
          structure: 'ساختار:',
          role: 'نقش:',
        },
        consultative: {
          title: 'مشاوره‌ای',
          role: 'مشاور مورد اعتماد',
          goal: 'درک عمیق دنیای مشتری',
          tone: 'همدلانه، کنجکاو، حمایت‌کننده',
          structure: 'سوالات باز ← اکتشافی ← مشاوره‌ای',
          description: 'بهترین انتخاب برای خدمات پیچیده که نیاز به درک عمیق نیازهای مشتری دارند',
        },
        transactional: {
          title: 'معامله‌ای',
          role: 'بسته‌کننده سریع معامله',
          goal: 'ارائه اطلاعات کلیدی و بستن معامله',
          tone: 'کارآمد، مستقیم، متقاعدکننده',
          structure: 'ویژگی ← مزیت ← بستن معامله',
          description: 'مناسب برای محصولات ساده با قیمت پایین که نیاز به توضیح زیاد ندارند',
        },
        solutionBased: {
          title: 'مبتنی بر راه‌حل',
          role: 'معمار راه‌حل',
          goal: 'ربط دادن مشکل مشتری به قابلیت‌های محصول',
          tone: 'تحلیلی، حل‌کننده مشکل',
          structure: 'تشخیص ← تطبیق ← اثبات ارزش',
          description: 'بهترین انتخاب برای محصولات فناوری یا خدمات پیچیده که مشکل خاصی را حل می‌کنند',
        },
        challenger: {
          title: 'چالش‌گر',
          role: 'تحریک‌کننده بصیرت‌آفرین',
          goal: 'تغییر نگرش کاربر',
          tone: 'جسور، مقتدر، آموزشی',
          structure: 'آموزش ← تطبیق ← کنترل',
          description: 'مناسب برای بازارهای رقابتی که نیاز به تغییر نگرش مشتری دارند',
        },
        spin: {
          title: 'اسپین',
          role: 'مصاحبه‌کننده تشخیصی',
          goal: 'هدایت کاربر برای درک نیاز خودش',
          tone: 'کنجکاو، روش‌مند',
          structure: 'موقعیت ← مشکل ← پیامد ← نیاز-بازده',
          description: 'بهترین انتخاب برای فروش‌های B2B پیچیده که نیاز به کشف نیازهای پنهان دارند',
        },
        sandler: {
          title: 'سندلر',
          role: 'راهنمای برابر و هوش عاطفی',
          goal: 'واجد شرایط کردن کاربر از نظر عاطفی و منطقی قبل از ارائه راه‌حل',
          tone: 'آرام، کاوشگر، روان‌شناختی',
          structure: 'ارتباط ← درد ← بودجه/تصمیم ← پس از فروش',
          description: 'مناسب برای فروش‌های با ارزش بالا که نیاز به اعتماد عمیق دارند',
        },
      },
      salesTime: {
        title: 'زمان استراحت آیدا',
        description: 'در این بخش می‌توانید زمان استراحت آیدا را تنظیم کنید که آیدا در چه زمانی به مشتریان پاسخ ندهد.',
        addRestTime: 'افزودن تایم استراحت',
        cancel: 'انصراف',
        restDay: 'روز استراحت',
        days:{
          saturday: 'شنبه',
          sunday: 'یکشنبه',
          monday: 'دوشنبه',
          tuesday: 'سه‌شنبه',
          wednesday: 'چهارشنبه',
          thursday: 'پنج‌شنبه',
          friday: 'جمعه',
        },
        restTime: 'زمان استراحت',
        emptyDescription: 'آیدا، همیشه پر قدرت در حال ارائه خدمات به مخاطبان شما است.',
        table:{
          restDay: 'روز استراحت',
          startTime: 'شروع استراحت',
          endTime: 'اتمام استراحت',
          actions: 'عملیات',
        },
        error: {
          timeRequired: 'زمان باید وارد شود',
          timeFormat: 'فرمت زمان باید HH:MM باشد',
          timeHour: 'ساعت باید عدد باشد',
          timeMinute: 'دقیقه باید عدد باشد',
          timeStartBeforeEnd: 'زمان شروع باید قبل از زمان پایان باشد',
          timeOverlaps: 'بازه‌های زمانی نباید با هم تداخل داشته باشند',
          timeHourMin: 'ساعت نمی‌تواند کمتر از 0 باشد',
          timeHourMax: 'ساعت نمی‌تواند بیشتر از 23 باشد',
          timeMinuteMin: 'دقیقه نمی‌تواند کمتر از 00 باشد',
          timeMinuteMax: 'دقیقه نمی‌تواند بیشتر از 59 باشد',
          errorDelete: 'خطا در حذف زمان استراحت.',
        },
        success: 'زمان استراحت با موفقیت ثبت شد',
      },
      tabs: {
        tab1: 'عمومی',
        tab2: 'روش شناسی',
        tab3: 'تنظیمات پیشرفته',
      },
      advanced_setting: {
        advanced_setting: 'تنظیمات پیشرفته آیدا',
        lock_open: 'وظیفه باز شد',
        lock_close: 'وظیفه قفل شد',
        lock_error: 'خطا در تغییر وضعیت قفل',
        ok_edit: 'وظیفه با موفقیت به‌روزرسانی شد',
        ok_add: 'وظیفه با موفقیت افزوده شد',
        error_edit: 'خطا در به‌روزرسانی وظیفه',
        error_add: 'خطا در افزودن وظیفه',
        ok_delete: 'وظیفه با موفقیت حذف شد',
        error_delete: 'خطا در حذف وظیفه',
        add_subtask_: 'افزودن وظیفه',
        days: {
          saturday: 'شنبه',
          sunday: 'یکشنبه',
          monday: 'دوشنبه',
          tuesday: 'سه‌شنبه',
          wednesday: 'چهارشنبه',
          thursday: 'پنجشنبه',
          friday: 'جمعه',
        },
        error_fetch: 'خطا در دریافت وظیفه ها',
        zero_fetch: 'هیچ وظیفه یافت نشد',
        subtask:'وظیفه آیدا',
        subtask_reason: 'دلیل انجام وظیفه',
        subtask_kpi: 'شاخص موفقیت وظیفه',
        description: 'توضیحات',
        reason: 'دلیل',
        kpi: 'شاخص موفقیت',
        cancel: 'انصراف',
        ok: 'تایید',
        add_subtask: 'افزودن وظیفه جدید',
        add_subtask_des: 'در بخش وظیفه، شما وظیفه ای که میخواهید آیدا آن را انجام دهد را می نویسید.',
        add_subtask_des2: 'در بخش دلیل ، شما دلیل اینکه آیدا باید وظیفه ای را که مشخص کردید انجام دهد را وارد کنید.',
        add_subtask_des3: 'در بخش  شاخص موفقیت، شما شاخص موفقت آیدا را در انجام وظیفه ای که به او داده اید مشخص کنید.',
        delete_subtask: {
          confirm: 'تایید حذف وظیفه',
          description: 'آیا مطمئن هستید که می‌خواهید این وظیفه را حذف کنید؟',
          notback: 'این عمل قابل بازگشت نیست.',
          deleteit: 'حذف کن',
          cancelit: 'انصراف'
        },
        descriptiontext: {
          des1: 'در بخش تنظیمات پیشرفته آیدا، می‌توانید وظایفی را که آیدا باید انجام دهد مشخص کنید. آیدا بر اساس اطلاعاتی که از شما دریافت می‌کند، به‌صورت خودکار وظایف و دستورعمل‌های موردنیاز را طبقه‌بندی کرده و مجموعه‌ای از وظایف پیش‌فرض را ایجاد می‌کند. با این حال، اگر احساس می‌کنید آیدا باید کار یا وظیفه دیگری را نیز در برنامه خود داشته باشد، می‌توانید از طریق دکمه افزودن وظیفه موارد دلخواهتان را اضافه کنید.',
          des2: 'توجه داشته باشید که با هر بار تغییر در اطلاعات شما، وظایف خودکار آیدا نیز ممکن است تغییر کنند. بنابراین اگر وظیفه‌ای برای شما اهمیت ویژه‌ای دارد و می‌خواهید بدون تغییر باقی بماند، می‌توانید با استفاده از دکمه قفل آن را ثابت کنید. همچنین با دکمه ویرایش می‌توانید اطلاعات هر وظیفه را اصلاح کرده و در صورت عدم نیاز به یک وظیفه، با دکمه حذف آن را از فهرست حذف کنید.',
          des3: 'در حال حاضر امکان تعریف حداکثر ۱۰ وظیفه برای آیدا وجود دارد. تعداد وظایف قابل افزودن در دکمه افزودن وظیفه نمایش داده می‌شود و پس از رسیدن به سقف مجاز، این دکمه به‌طور خودکار غیرفعال خواهد شد.',
        }
      }
    },
    validation: {
        phoneValidationPattern: 'شماره تلفن باید با فرمت +989123456789 وارد شود',
        phoneValidationRequired: 'شماره تلفن الزامی است',
        emailValidation: 'ایمیل نامعتبر است',
        emailValidationRequired: 'ایمیل الزامی است',
        otpValidationPattern: 'کد تایید باید 6 رقم باشد',
        otpValidationRequired: 'کد تایید الزامی است',
        fullNameValidationRequired: 'نام و نام خانوادگی الزامی است',
        fullNameValidationMin: 'نام و نام خانوادگی باید حداقل 3 کاراکتر باشد',
        positionValidationRequired: 'سمت شغلی الزامی است',
        positionValidationMin: 'سمت شغلی باید حداقل 2 کاراکتر باشد',
        bussinessDescriptionValidationRequired: 'توضیحات کسب و کار الزامی است',
        bussinessDescriptionValidationMin: 'توضیحات کسب و کار باید حداقل 10 کاراکتر باشد',
        businessNameValidation: 'نام کسب و کار نامعتبر است',
        businessNameValidationRequired: 'نام کسب و کار الزامی است',
        serviceTypeValidationRequired: 'نوع خدمات الزامی است',
        serviceTypeValidationMin: 'نوع خدمات باید حداقل 2 کاراکتر باشد',
        serviceDescriptionValidationRequired: 'توضیحات خدمات الزامی است',
        serviceDescriptionValidationMin: 'توضیحات خدمات باید حداقل 10 کاراکتر باشد',
        targetAudienceValidationRequired: 'مخاطبان هدف الزامی است',
        targetAudienceValidationMin: 'مخاطبان هدف باید حداقل 10 کاراکتر باشد',
        interactionStyleValidation: 'سبک تعامل نامعتبر است',
        interactionStyleValidationRequired: 'سبک تعامل الزامی است',
        instagramUsernameValidationRequired: 'نام کاربری اینستاگرام الزامی است',
        instagramUsernameValidationMin: 'نام کاربری اینستاگرام باید حداقل 3 کاراکتر باشد',
        instagramPasswordValidationRequired: 'رمز عبور اینستاگرام الزامی است',
        instagramPasswordValidationMin: 'رمز عبور اینستاگرام باید حداقل 6 کاراکتر باشد',
        channelsValidationRequired: 'کانال های ارتباطی الزامی است',
        channelsValidationMin: 'کانال های ارتباطی باید حداقل 1 کاراکتر باشد',
        planValidationRequired: 'پلن الزامی است',
        durationValidation: 'دوره اشتراک نامعتبر است',
        durationValidationRequired: 'دوره اشتراک الزامی است',
    },
    knowledgeBase: {
      tabs: {
        tab1: 'مدیریت دانش',
        tab3: 'گراف دانش',
        tab2: 'گفتگو با دانش',
      },
      noAccess: 'شما به هیچ بخشی از پایگاه دانش دسترسی ندارید.',
    },
    aidaSettings: {
      tabs: {
        tab1: 'دانش',
        tab2: 'فعالیت‌ها',
        tab3: 'کمپین',
        tab4: 'اطرافیان',
        tab5: 'رفتارها',
        tab6: 'تنظیمات',
      },
    },
    profileAndBusiness: {
      tabs: {
        profile: 'پروفایل',
        business: 'کسب و کار',
      },
    },
  },
  en: {
    steps: {
      channel: {
        title: 'In this section, you need to manage your communication channel information and enable or disable any channel you want.',
        instagram: {
          step1: 'Using this option, you can connect your Instagram account to Aida. After connection, whenever you need, by activating or deactivating this feature, you will have access to Aida\'s services and features on Instagram.',
          step2: 'By selecting this option, Aida\'s features will be activated on your Instagram account. After activation, Aida can help you manage messages, respond to customers, and introduce products on Instagram.',
        },
        telegram: {
          step1: 'Using this option, you can connect your Telegram account to Aida. After connection, whenever you need, by activating or deactivating this feature, you will have access to Aida\'s services and features on Telegram.',
        },
        website: {
          step1: 'Using this option, you can connect your website to Aida. After connection, whenever you need, by activating or deactivating this feature, you will have access to Aida\'s services and features on your website.',
        },
        bale: {
          step1: 'Using this option, you can connect your Bale account to Aida. After connection, whenever you need, by activating or deactivating this feature, you will have access to Aida\'s services and features on Bale.',
        },
      },
      knowledge: {
        title: 'In this section you can view and edit your knowledge. This information helps Aida to better understand your knowledge and help you better.',
        step1: 'Using this option, you can connect your knowledge to Aida. After connection, whenever you need, by activating or deactivating this feature, you will have access to Aida\'s services and features on your knowledge.',
        step2: 'Using this option, you can add new knowledge to Aida. After adding, you will have access to Aida\'s services and features on your knowledge.',
        step3: "Using this button, you can select and delete a specific item of knowledge stored in Aida's memory. This feature allows you to manage specific content without completely clearing the memory. Note that this option is not displayed when no knowledge has been stored yet.",
      },
      profile: {
        title: 'This section allows you to edit your account profile information related to the admin, including first and last name, phone number, and job title.',
      },
      profile_onboarding: {
        title: 'In this section you can enter your personal information.',
        step1: 'In this field you can enter your full name.',
        step2: 'In this field you can enter your phone number.',
        step3: 'In this field you can enter your position.',
      },
      business_onboarding: {
        title: 'In this section you can enter your business information. This information helps Aida to better understand your business and help you better.',
        step1: 'Using this field, you can enter your business name.',
        step2: 'Using this field, you can enter your business type.',
        step3: 'Using this field, you can enter your business size.',
        step4: 'Using this field, you can enter your business address.',
        step5: 'Using this field, you can enter your business description. Anything you think is necessary for Aida to know, write it here. The quality of Aida depends on the information you enter here.',
        step6: 'Enter additional information in your business here.',
      },
      payments: {
        title: 'In this section, you can view your complete payment history.',
        step1: 'Using these date fields, you can specify the start and end dates for payments and view payments made during that period.',
        step2: 'Full details of payment information and history can be viewed in this section.',
      },
      business: {
        title: 'In this section, you can manage and edit your business information. Accurately recording this information helps Aida know your business better and provide you with better services.',
        step1: 'In this section, you can enter or edit your business name.',
        step2: 'This section allows you to enter your business type.',
        step3: 'The size of your business can be viewed and determined in this section.',
        step4: 'In this section you can enter your business address.',
        step5: "In this section, you can enter a description of your business. Enter any information you think is useful for Aida here, because the quality of Aida's performance depends on the accuracy of the information you enter.",
        step6: 'In this section, you can enter additional descriptions about your business.',
      },
      service: {
        title: 'In this section, you can manage and edit information about the services provided by your business.',
        step1: 'In this section, you can specify the type of services provided by your business. If your service does not fit into any of the categories, select the "Other" option and enter a full description in the Service Description section.',
        step2: "In this section, you can enter descriptions of the services provided by your business. Please record the information completely and accurately, as this data plays an important role in improving Aida's performance.",
        step3: 'In this section, you can specify the audience for your business services. These audiences can be customers, companies, or other individuals.',
      },
      service_onboarding: {
        title: 'In this section you can enter your service information. This information helps Aida to better understand your service and help you better.',
        step1: 'Using this field, you can enter your service type. The service type can be consultation, training, or service. If you are outside of these three types, select other and write the exact description in the service description field.',
        step2: 'Using this field, you can enter your service description. The service description must be exact and complete.',
        step3: 'Using this field, you can enter your target audience. The target audience can be customers, companies, or other people.',
      },
      behavior: {
        title: 'One of the attractive features of Aida is its customization. You can customize Aida for your business so that the responses are provided according to your wishes.',
        step1: "In this section, you can determine Aida's conversation style with your contacts.",
        step2: "In this section, you can specify Aida's sales method so that Aida can make sales according to the selected method. Each method has its own characteristics and structure, so adjust it based on your business needs and considerations.",
        step3: 'In this section, you can specify the response style of Aida so that Aida will respond according to the selected style.',
        step4: 'In this section, you can specify the length of Aida\'s responses so that Aida will respond according to the selected length.',
        step5: 'In this section, you can set the time to rest Aida that Aida will not respond to the users. By using the add button, you can enter the time you do not want Aida to respond in. Then, by using the green button, you can save the times you have entered.',
      },
      autoResponse: {
        title: 'This section allows you to define predefined responses to specific questions, words, or sentences.',
        step1: 'Using this button, you can add predefined responses to Aida for specific words or sentences.',
        step2: 'You can use this button to delete the predefined answers. This will completely clear all predefined answers.',
        step3: 'This button allows you to select and delete a specific item from the predefined responses. This feature allows you to manage specific responses without completely clearing all responses. Note that this option is not displayed when an item has not yet been saved.',
      },
      conversation: {
        title: "This section allows you to view Aida's conversations with users. All channels in which Aida has interacted with your users are displayed here.",
      },
      chatbox: {
        step1: 'In the chat box section, you have a demo version of Aida and you can chat with her. All your conversations are saved in the conversation history section.',
        step2: 'You can see the chat box codes in the documentation section. For more information about connecting Aida to your website, refer to the relevant documentation.',
        step3: 'In the chat box settings section, you can adjust the chat box position. Then use the generated code snippet to add the chat box to your website.',
      },
      dashboard: {
        title: 'Welcome to Aida\'s Dashboard! Here you can view the overall knowledge and performance of your system.',
        videoButton:'The video button on each page shows you the video tutorial for that page. Using this button, you can understand all the details of that page.',
        helpButton: 'The Help button on each page provides you with a complete description of that section.',
        sidebar: "Through this menu, you can access all of Aida's settings and sections.",
        subscriptionInfo: 'In this section, you can see the plan type and the number of days remaining on your subscription.',
        logoutButton: 'You can log out of your account using this button.',
        knowledgeStats: 'In this section, you can see the number of entries, characters, and tokens used, as well as the estimated cost spent on your account.',
        totalEntries: 'The total number of entries in your knowledge is displayed here.',
        totalCharacters: 'The total number of characters in your knowledge is displayed here.',
        estimatedTokens: 'The total number of estimated tokens used for processing your knowledge is displayed here.',
        estimatedCost: 'The estimated cost of processing your knowledge based on the tokens used is displayed here.',
        hamburgerMenu: 'You can access all of Aida\'s settings and sections through this menu.',
        userInfo: 'This section shows your account details such as your name, email, and phone number. If you want to edit them, click the gear icon to open your profile page and update your information.',
        activeChannels: 'Here you can see all your communication channels like Telegram or Instagram. Each channel’s status is shown — green means active, red means inactive. Click the gear icon to manage or add new channels.',
        knowledgeCount: 'This section shows how many “knowledge entries” you’ve added and the latest ones.Each knowledge entry is a piece of content or an FAQ you’ve created. Use the gear icon to manage your knowledge items.',
        conversations: 'This chart shows how many messages were received through each channel. It helps you see which channel has been more active. Click the gear icon to open the full conversation history.',
        conversationsLast7Days: 'Similar to the previous section, but limited to the last 7 days. It helps you see how active your channels were during the past week.',
        tokenUsage: 'This section shows how many tokens have been used by Aida. The pie chart displays input and output token counts to help you monitor your usage easily.',
        activeIntegrations: 'Here you can see your active friends — people connected to your Aida account. Click the gear icon to open the friends page and manage your connections.',
        recentPayments: 'This section lists your most recent payments. You can see the purpose and amount of each payment. Click the gear icon to view your full payment history.',
      },
      subscription: {
        step1: 'In this section you can select the Aida model and view the panels and descriptions of each Aida.',
        step2: 'In this section you can select the duration of the Aida subscription.',
      },
      marketplace: {
        title: 'In this section, you can see Aida integrations that are available for connection. By activating them, you can use their features in Aida.',
      },
      myIntegrations: {
        title: 'In this section, you can view the status of Aida integrations for your account, whether they are active or inactive.',
      }
    },
    video: {
      dashboard: 'Dashboard Tutorial',
      profile: 'Profile Tutorial',
      business: 'Business Tutorial',
      payments: 'Payments Tutorial',
      channel: 'Channels Tutorial',
      aidaSetting: 'Advanced Aida Settings Tutorial',
      knowledge: 'Knowledge Tutorial',
      autoResponse: 'Auto Response Tutorial',
      chatHistory: 'Chat History Tutorial',
      chatBox: 'Chatbox Tutorial',
      marketPlace: 'Marketplace Tutorial',
      myIntegrations: 'My Integrations Tutorial',
      signup: 'Sign-up Tutorial',
    },
    // Auth
    auth: {
      login: {
        title: 'Login to Account',
        phoneStep: 'Enter Phone Number',
        emailStep: 'Enter Email',
        otpStep: 'Verify OTP',
        phoneLabel: 'Phone Number',
        phonePlaceholder: '+989123456789',
        emailLabel: 'Email',
        emailPlaceholder: 'example@gmail.com',
        phoneMethod: 'Phone',
        emailMethod: 'Email',
        otpLabel: 'Verification Code',
        otpPlaceholder: '6-digit code',
        sendOtp: 'Send Code',
        verifyAndLogin: 'Verify and Login',
        noAccount: "Don't have an account?",
        signupLink: 'Sign up',
        userNotFound: 'User with this phone number does not exist. Please sign up first.',
        signup: 'Sign up',
        validationError: 'Invalid information provided',
        tooManyRequests: 'Too many requests. Please wait a moment',
        serverError: 'Server error. Please try again',
        serviceUnavailable: 'Service unavailable. Please try later',
        networkError: 'Network error. Please check your internet connection',
        genericError: 'An error occurred. Please try again',
      },
      signup: {
        title: 'Sign up for Aida',
        phoneStep: 'Enter Phone Number',
        emailStep: 'Enter Email',
        otpStep: 'Verify OTP',
        phoneLabel: 'Phone Number',
        phonePlaceholder: '+989123456789',
        emailLabel: 'Email',
        emailPlaceholder: 'example@gmail.com',
        phoneMethod: 'Phone',
        emailMethod: 'Email',
        otpLabel: 'Verification Code',
        otpPlaceholder: '6-digit code',
        sendOtp: 'Send Code',
        verifyAndSignup: 'Verify and Sign up',
        haveAccount: 'Already have an account?',
        loginLink: 'Login',
      },
      errors: {
        badRequest: 'Invalid request. Please check the information you entered.',
        validationError: 'Invalid information provided. Please fill in all required fields.',
        tooManyRequests: 'Too many requests. Please wait a moment.',
        serverError: 'Server error. Please try again.',
        serviceUnavailable: 'Service unavailable. Please try later.',
        networkError: 'Network error. Please check your internet connection.',
        unknownError: 'Unknown error. Please try again.',
        invalidOtp: 'Invalid verification code. Please enter the correct code.',
        otpExpired: 'Verification code has expired. Please request a new code.',
        userAlreadyExists: 'A user with this information already exists.',
        invalidPhoneNumber: 'Invalid phone number. Please enter a valid number.',
        invalidEmail: 'Invalid email. Please enter a valid email address.',
        userNotFound: 'User with this information not found. Please sign up first.',
        waitRequest: 'Please try again later.',
      },
      language: {
        label: 'Language',
        fa: 'Persian',
        en: 'English',
      },
    },
    // Dashboard
    dashboard: {
      title: 'Dashboard',
      userInfo: {
        title: 'Personal Information',
        fullName: 'Full Name',
        email: 'Email',
        phoneNumber: 'Phone Number',
        languagePreference: 'Language',
        createdAt: 'Registration Date',
        notSet: 'Not Set',
      },
      systemPrompt: {
        title: 'Recognition of Aida from you',
        noSystemPrompt: 'Aida has not yet recognized your business! Please go to the profile and business pages to complete your information.',
        showMore: 'Show More',
        close: 'Close',
      },
      activeChannels: {
        title: 'Active Channels',
        telegram: 'Telegram',
        bale: 'Bale',
        instagram: 'Instagram',
        website: 'Website',
        kavenegar: 'Kavenegar',
        instagram_comment: 'Instagram Comment',
        noChannels: 'No active channels',
      },
      knowledgeCount: {
        title: 'Knowledge Count',
        count: 'Knowledge',
        lasts_knowledge: 'Last Knowledge',
        type: 'Type',
        content: 'Content',
        noKnowledge: 'The knowledge table is currently empty',
      },
      conversations: {
        title: 'Conversation History',
        totalMessages: 'Total Messages',
        byChannel: 'By Channel',
        noConversations: 'No conversations found',
      },
      conversationsLast7Days: {
        title: 'Last 7 Days Conversations',
        messages: 'Messages',
        noConversations: 'No conversations found',
      },
      tokenUsage: {
        title: 'Token Usage',
        inputTokens: 'Input Tokens',
        outputTokens: 'Output Tokens',
        totalTokens: 'Total Tokens',
        noTokensExchanged: 'No tokens have been exchanged yet',
      },
      activeIntegrations: {
        title: 'Active Friends',
        count: 'Active Friend(s)',
        noActiveIntegrations: 'No active integrations found',
      },
      recentPayments: {
        title: 'Recent Payments',
        amount: 'Amount',
        plan: 'Subscription',
        refId: 'Reference ID',
        noPayments: 'No payments found',
      },
      error: {
        fetchError: 'Error fetching dashboard data. Please try again.',
        sessionExpired: 'Session expired. Please login again.',
      },
      chatbox: {
        welcomeParagraphs: [
          'Hi 👋\nWelcome to the {bold}Aida Panel{bold}.',
          "I'm {bold}Aida{bold}, your smart sales assistant 🤖\nI'm here to help you connect with customers using AI—respond faster, communicate better, and grow your sales.",
          'To give your customers more accurate, professional answers, teach me about your business in {bold}Aida Knowledge{bold} [icon:knowledge].',
          'Add PDFs, Excel files, website links, text, and any details you need to my knowledge base so my replies always match your business information and rules.',
          'In {bold}Aida Settings{bold} [icon:settings], you can personalize how I work.',
          'From communication channels to how I chat with customers, quick replies, managing Aida friends, and the rules I follow when responding—everything is managed here.',
          'In {bold}Conversations{bold} [icon:conversations], you can view and review all chats with your customers.',
          'Chats are grouped by channel so you can find conversations quickly and keep improving the quality of my replies.',
          'In {bold}Profile{bold} [icon:profile], you can complete your personal and business information.',
          'The more I know about your business, the better I can understand your customers and give the right answers.',
          'In {bold}Chatbox{bold} [icon:chatbox], you can fully customize the chat widget for your website.',
          'After setup, your personal Script code is generated. Use the guides in that section to add it to your site so I’m ready to chat with your customers.',
          'If you have a question about any section, talk to me through the chatbox at the bottom of the page 💬\nI’m always here to help.',
          'We hope you have a smooth, useful experience with Aida ✨',
        ],
        clearChatHistory: 'Clear Chat History',
        title: 'Aida',
        chatboxPlaceholder: 'Enter your message...',
        errorMessage: 'Sorry, an error occurred. Please try again.',
        isTyping: 'Typing...',
        howCanIHelpYou: 'Hello to you :) \nHow can I help you?',
      }
    },
    // Menu
    menu: {
      dashboard: 'Dashboard',
      you: 'You',
      payments: 'Payments',
      profile: 'Profile',
      business: 'Business',
      services: 'Services',
      aida: 'Aida',
      channels: 'Channels',
      behavior: 'Behavior',
      knowledgeCenter: 'Knowledge Center',
      conversation: 'Conversation',
      conversationHistory: 'Conversation History',
      chatbox: 'Chatbox',
      marketplace: 'Aida\'s Circle',
      myIntegrations: 'Aida\'s Friends',
      subscriptionRenewal: 'Subscription Renewal',
      addKnowledge: 'Add Knowledge',
      knowledgeStats: 'Knowledge Stats',
      deleteAllKnowledge: 'Delete All Knowledge',
      knowledgeList: 'List of the Knowledge',
      knowledgeGraph: 'Knowledge Graph',
      daysRemaining: 'days remaining',
      logout: 'Logout',
      automateResponseBot: 'Automate Response Bot',
      salesCampaign: 'Sales Campaign',
    },
    // Marketplace
    marketplace: {
      title: 'Aida\'s Circle',
      description: 'Discover and add Aida\'s powerful friends to enhance her capabilities.',
      searchPlaceholder: 'Search friends...',
      learnMore: 'Learn More',
      addToAida: 'Add Friend',
      monthlyPrice: '/month',
      active: 'Active',
      inactive: 'Inactive',
      loading: 'Loading friends...',
      error: 'Failed to load friends. Please try again.',
      empty: 'No friends found',
      emptyDescription: 'Try adjusting your search terms or check back later for new friends.',
      integrationAdded: 'Friend successfully added to your Aida!',
      integrationAddError: 'Failed to add friend',
      configurationRequirements: 'Configuration Requirements',
      requiredFields: 'Required Fields:',
      optionalFields: 'Optional Fields:',
      sensitiveField: 'Sensitive',
      defaultValue: 'Default',
      termsAndConditions: 'Terms & Conditions',
      visitWebsite: 'Visit Website',
      loadingDetails: 'Loading friend details...',
      failedToLoadDetails: 'Failed to load friend details',
      tryAgain: 'Try Again',
      descriptionTitle: 'Description',
      previous: 'Previous',
      next: 'Next',
      page: 'Page',
      of: 'of',
      myIntegrations: {
        title: 'Aida\'s Friends',
        description: 'Manage and configure Aida\'s friends.',
        filterAll: 'All',
        filterActive: 'Active',
        filterInactive: 'Inactive',
        configureIntegration: 'Configure Friend',
        editConfiguration: 'Edit Configuration',
        setupIntegration: 'Setup Friend',
        configured: 'Configured',
        setupRequired: 'Setup Required',
        notes: 'Notes:',
        configuration: 'Configuration:',
        noConfiguration: 'No configuration set',
        addedDate: 'Added:',
        updatedDate: 'Updated:',
        remove: 'Remove',
        removeIntegration: 'Remove Friend',
        cancel: 'Cancel',
        removeConfirm: 'Are you sure you want to remove this friend? This action cannot be undone.',
        integrationRemoved: 'Friend removed successfully!',
        integrationRemoveError: 'Failed to remove friend',
        configurationSaved: 'Friend configuration saved successfully!',
        configurationSaveError: 'Failed to save configuration',
        empty: 'No friends found',
        emptyActive: 'You don\'t have any active friends.',
        emptyInactive: 'You don\'t have any inactive friends.',
        emptyAll: 'You haven\'t added any friends yet.',
        browseMarketplace: 'Browse Aida\'s Circle',
        loadingIntegrations: 'Loading your friends...',
        noIntegrationsFound: 'No friends found',
        noActiveIntegrations: 'You don\'t have any active friends.',
        noInactiveIntegrations: 'You don\'t have any inactive friends.',
        noIntegrationsYet: 'You haven\'t added any friends yet.',
        failedToLoad: 'Failed to load friends',
        failedToRemove: 'Failed to remove friend',
        tryAgain: 'Try Again',
        filters: {
          all: 'All',
          active: 'Active',
          inactive: 'Inactive',
        },
        pagination: {
          previous: 'Previous',
          next: 'Next',
          pageInfo: 'Page {{page}} of {{totalPages}}',
        },
        configModal: {
          title: 'Configure',
          requiredConfig: 'Required Configuration',
          optionalConfig: 'Optional Configuration',
          notes: 'Notes',
          notesLabel: 'Friend Notes',
          notesPlaceholder: 'Add any notes about this friend configuration...',
          required: 'Required',
          cancel: 'Cancel',
          save: 'Save Configuration',
          saving: 'Saving...',
          enableOption: 'Enable this option',
          selectOption: 'Select an option',
          invalidFormat: 'format is invalid',
          fieldRequired: 'is required',
        },
      },
      connections: {
        didarAdvancedTab: 'Didar Advanced Settings',
        didarMissingIntegration:
          'To open Didar form settings, add Didar to your integrations first.',
        didarAdvanced: {
          supplementaryLabel: 'Supplementary notes for Aida',
          supplementaryFieldLegend: 'Supplementary notes for Aida',
          supplementaryPlaceholder:
            'Specify under what conditions or when this form should be collected from the user...',
          submitIncomplete: 'Please complete descriptions for all fields and the form collection conditions.',
          submitNoIntegration:
            'No active Didar integration found. Please activate Didar in My Integrations first.',
          newFormConfirmTitle: 'Register a new Didar form',
          newFormConfirmMessage:
            'You already have a saved form, and you are now trying to set up a different form. Registering the new form will clear your previous form data. Do you want to continue?',
          newFormConfirmYes: 'Yes, I want the new form',
          newFormConfirmCancel: 'Cancel',
          submitPreviewTitle: 'JSON output (test)',
          help: {
            title: 'More information',
            pageSetupTitle: 'About configuring and defining form fields',
            pageSetupP1:
              'On this page, you enter a form URL and the system automatically detects and displays the form at that address.',
            pageSetupP2:
              'Form fields may include various information such as name, phone number, email, company name, and more.',
            pageSetupP3:
              'Below each displayed field there is an input where you should write the description for that field.',
            fieldPurposeIntro: 'The purpose of these descriptions is to clarify:',
            fieldPurposeGoals: [
              'What each field means',
              'What information should be entered',
              'What value the end user should submit for that field',
            ],
            fieldPurposeClosing:
              'These descriptions help the system better understand your intent for each variable and collect more accurate information from users.',
            exampleTitle: 'Example',
            exampleCompany:
              'If the form has a field titled "Company name", you might write: Enter the name of the company where the user currently works.',
            examplePhone:
              'For a "Phone number" field you might write: Enter the user\'s active, reachable phone number including country code.',
            displayConditionsTitle: 'When to show or collect the form',
            displayConditionsP1:
              'At the bottom of the page there is another input where you specify under what conditions or when the form should be collected from the user.',
            displayConditionsP2:
              'In this section you can describe the scenario or situation in which the form should be shown.',
            displayExamplesTitle: 'Examples',
            displayExamples: [
              'When the user is purchasing a product',
              'When the user has shown interest in a product',
              'After submitting a consultation request',
              'During sign-up or account creation',
            ],
            displayConditionsClosing:
              'This section helps the system decide when the form should be shown to the user or when its data should be collected.',
          },
        },
      },
    },
    // Channel
    channel: {
      title: 'Channel Settings',
      description: 'In this section you can manage your communication channel settings',
      instagram: {
        title: 'Instagram',
        description: 'Instagram can be used as a communication channel. To connect to Instagram, you must establish a connection.',
        enable: 'Enable Instagram',
        username: 'Instagram Username',
        connected: 'Instagram is connected',
        notConnected: 'Instagram is not connected. To enable Aida on Instagram, you must first establish a connection.',
        connect: 'Connect to Instagram',
        settings: 'Connection Settings',
        disconnect: 'Disconnect from Instagram',
        connecting: 'Connecting...',
        disconnecting: 'Disconnecting...',
        connectSuccess: 'Successfully connected to Instagram',
        disconnectSuccess: 'Successfully disconnected from Instagram',
        connectError: 'Error connecting to Instagram',
        disconnectError: 'Error disconnecting from Instagram',
        tokenExpires: 'Token expires',
        tokenInvalid: 'Instagram token is invalid. Please reconnect.',
        usernameHelper: 'Your business Instagram username for responding to messages',
        password: 'Instagram Password',
        passwordHelper: 'Your business Instagram account password',
      },
      telegram: {
        title: 'Telegram',
        description: 'Telegram can be used as a communication channel. To connect to Telegram, you must establish a connection.',
        descriptionHelper: 'Your Telegram Bot API Token',
        enable: 'Enable Telegram',
        bot_token: 'Telegram Bot Token',
        bot_token_helper: 'Your Telegram Bot API Token',
        connect: 'Connect to Telegram',
        settings: 'Connection Settings',
      },
      website: {
        title: 'Website',
        description: 'Website can be used as a communication channel. To connect to Website, you must establish a connection.',
        descriptionHelper: 'Your Website Chatbox ID',
        enable: 'Enable Website',
        chatbox_id: 'Website Chatbox ID',
        website_address: 'Website Address',
        connect: 'Connect to Website',
        settings: 'Connection Settings',
      },
      bale: {
        title: 'Bale',
        description: 'Bale can be used as a communication channel. To connect to Bale, you must establish a connection.',
        descriptionHelper: 'Your Bale Bot Token',
        enable: 'Enable Bale',
        bot_token: 'Bale Bot Token',
        connect: 'Connect to Bale',
        settings: 'Connection Settings',
      },
      kavenegar: {
        title: 'Kavenegar',
        description: 'Kavenegar can be used as a communication channel. To connect to Kavenegar, you must establish a connection.',
        descriptionHelper: 'Your Kavenegar API Key',
        enable: 'Enable Kavenegar',
        api_key: 'Kavenegar API Key',
      },
      save: 'Save',
      saving: 'Saving...',
      close: 'Close',
      active: 'Active',
      inactive: 'Inactive',
      success: 'Information updated successfully',
      error: {
        notFound: 'Channel information not found. Please complete the registration process first.',
        incomplete: 'Channel information is incomplete. Please fill in all required fields.',
        saveError: 'Error saving information. Please try again.',
        fetchError: 'Error fetching channel information. Please try again.',
        sessionExpired: 'Session expired. Please login again.',
      },
    },
    // Onboarding
    onboarding: {
      title: 'Complete Profile',
      steps: {
        personal: 'Personal Information',
        business: 'Business Information',
        service: 'Service Information',
        channel: 'Communication Channels',
        subscription: 'Subscription',
      },
      personal: {
        fullName: 'Full Name',
        fullNameHelper: 'Please enter your full name',
        phoneNumber: 'Phone Number',
        phoneNumberHelper: 'Please enter your phone number with country code',
        position: 'Position',
        positionHelper: 'Please enter your position',
        saveAndContinue: 'Save and Continue',
        saving: 'Saving...',
        success_message: 'Personal information saved successfully',
        email: 'Email',
        emailHelper: 'Please enter your email',
        error: {
          saveError: 'Error saving personal information. Please try again.'
        }
      },
      business: {
        businessName: 'Business Name',
        businessNameHelper: 'Please enter your business name',
        businessType: 'Business Type',
        businessSize: 'Business Size',
        businessDescription: 'Business Description',
        businessDescriptionHelper: 'Please enter a complete description of your business',
        address: 'Address',
        addressHelper: 'Please enter your business address',
        description: 'Description',
        descriptionHelper: 'Please enter additional business description',
        saveAndContinue: 'Save and Continue',
        saving: 'Saving...',
        save: 'Save',
        success: 'Business information saved successfully',
        error: {
          notFound: 'Business information not found. Please complete the registration process first.',
          incomplete: 'Business information is incomplete. Please fill in all required fields.',
          saveError: 'Error saving business information. Please try again.',
          fetchError: 'Error fetching business information. Please try again.',
        },
        types: {
          retail: 'Retail',
          service: 'Service',
          production: 'Production',
          shopping: 'Shopping',
          other: 'Other',
        },
        sizes: {
          small: 'Small',
          medium: 'Medium',
          large: 'Large',
        },
      },
      service: {
        title: 'Service Information',
        description: 'Please enter your service information',
        serviceType: 'Service Type',
        serviceTypeHelper: 'Please select your service type',
        serviceDescription: 'Service Description',
        serviceDescriptionHelper: 'Please enter a complete description of your services',
        targetAudience: 'Target Audience',
        targetAudienceHelper: 'Please describe your target audience',
        interactionStyle: 'Interaction Style',
        interactionStyleHelper: 'Please select your preferred interaction style',
        proactive: 'Proactive',
        reactive: 'Reactive',
        saveAndContinue: 'Save and Continue',
        saving: 'Saving...',
        success: 'Information updated successfully',
        error: {
          notFound: 'Service information not found. Please complete the registration process first.',
          incomplete: 'Service information is incomplete. Please fill in all required fields.',
          saveError: 'Error saving information. Please try again.',
          fetchError: 'Error fetching service information. Please try again.',
        },
        types: {
          consultation: 'Consultation',
          training: 'Training',
          service: 'Service',
          other: 'Other',
        },
        interactionStyles: {
          proactive: 'Proactive',
          reactive: 'Reactive',
        },
      },
      channel: {
        instagram: 'Instagram',
        enableInstagram: 'Enable Instagram',
        instagramUsername: 'Instagram Username',
        instagramUsernameHelper: 'Your business Instagram username for responding to messages',
        instagramPassword: 'Instagram Password',
        instagramPasswordHelper: 'Your business Instagram account password',
        telegram: 'Telegram',
        enableTelegram: 'Enable Telegram',
        telegramBotToken: 'Telegram Bot Token',
        telegramBotTokenHelper: 'Your Telegram Bot API Token',
        website: {
          title: 'Website',
          enable: 'Enable Website',
          chatbox_id: 'Website Chatbox ID',
          website_address: 'Website Address',
          invalidUrl: 'Please enter a valid website address (e.g., https://example.com)',
        },
        bale: {
          title: 'Bale',
          enable: 'Enable Bale',
          bot_token: 'Bale Bot Token',
        },
        kavenegar: {
          title: 'Kavenegar',
          enable: 'Enable Kavenegar',
          api_key: 'Kavenegar API Key',
        },
        saveAndContinue: 'Save and Continue',
        saving: 'Saving...',
      },
      subscription: {
        none: 'No subscription',
        plan: 'Plan',
        duration: 'Duration',
        quarterly: 'Quarterly',
        semiannual: 'Semiannual',
        annual: 'Annual',
        intern: 'Intern',
        expert: 'Expert',
        business: 'Business',
        master: 'Master',
        initiatePayment: 'Initiate Payment',
        verifying: 'Verifying...',
        plans_info: {
          seller: {
            intern: {
              title: "Intern",
              price: "0",
              features: [
                '1 active channel',
                '1 active friend',
                '5 concurrent responses',
                'Normal speed in response',
                'Normal mind presence',
                '50 messages per month',
                '24 hours of conversation storage',
                'Support via ticket',
              ]
            },
            expert: {
              title: "Expert",
              price: "49",
              features: [
                '3 active channels',
                '2 active friends',
                '20 concurrent responses',
                'Good speed in response',
                'Good mind presence',
                '5000 messages per month',
                '30 days of conversation storage',
                'Support via ticket and chat with customer expert',
              ]
            },
            master: {
              title: "Master",
              price: "169",
              features: [
                '10 active channels',
                '10 active friends',
                '100 concurrent responses',
                'Excellent speed in response',
                'Excellent mind presence',
                '10000 messages per month',
                '6 months of conversation storage',
                'Support via ticket and chat with customer expert',
              ]
            }
          },
          assistant: {
            intern: {
              title: "Intern",
              price: "0",
              features: [
                '1 active channel',
                '1 active friend',
                '1 concurrent response',
                'Normal speed in response',
                'Normal mind presence',
                '20 messages per month',
                '24 hours of conversation storage',
                'Support via ticket',
              ]
            },
            expert: {
              title: "Expert",
              price: "29",
              features: [
                '3 active channels',
                '2 active friends',
                '10 concurrent responses',
                'Good speed in response',
                'Good mind presence',
                '1000 messages per month',
                '30 days of conversation storage',
                'Support via ticket and chat with customer expert',
              ]
            },
            master: {
              title: "Master",
              price: "69",
              features: [
                '10 active channels',
                '10 active friends',
                '40 concurrent responses',
                'Excellent speed in response',
                'Excellent mind presence',
                '5000 messages per month',
                '6 months of conversation storage',
                'Support via ticket and chat with customer expert',
              ]
            }
          }
        },
        durations: {
          quarterly: 'Quarterly',
          semiannual: 'Semiannual',
          annual: 'Annual',
        },
        types: {
          seller: 'Seller',
          assistant: 'Assistant',
        },
        messeges: {
          success: {
            expert: 'Expert subscription activated successfully',
            master: 'Master subscription activated successfully',
          },
          error: 'Error activating subscription'
        },
        payment: {
          processing: 'Processing request...',
          active: 'Intern subscription activated successfully',
          active_intern: 'Activate Intern',
          button: 'Pay and Activate',
        },
        title: {
          selectPlan: 'Select Subscription Plan',
          selectType: 'Aida Type',
          free: 'Free',
          cash_type: 'Dollars',
          intern_description: '14 days intern',
          semiannual_description: 'Semiannual (10% discount)',
          quarterly_description: 'Quarterly',
          annual_description: 'Annual (20% discount)',
          button: 'Select',
          duration_title_select: 'Subscription Duration',
          intern_description_select: 'This plan has 14 days validity (can be activated only once)',
          semiannual_description_select: ' /Semiannual (10% discount)',
          quarterly_description_select: ' /Quarterly',
          annual_description_select: ' /Annual (20% discount)',
          temp1: 'Subscription',
          mamad: ' / 14 days intern',
        },
        coupon: {
          coupon_code: 'Coupon Code',
          coupon_code_helper: 'Enter your coupon code',
          discount_factor: 'Discount Factor',
          discount_factor_helper: 'Activated for you.',
          valid_coupon: 'Valid coupon',
          invalid_coupon: 'Invalid coupon',
          error_checking_coupon: 'Error checking coupon',
          please_enter: 'Enter the Coupon Code'
        }
      },
    },
    // Common
    common: {
      loading: 'Loading...',
      error: 'Error',
      success: 'Success',
      save: 'Save',
      cancel: 'Cancel',
      back: 'Back',
      next: 'Next',
      submit: 'Submit',
      delete: 'Delete',
      edit: 'Edit',
      search: 'Search',
      filter: 'Filter',
      sort: 'Sort',
      refresh: 'Refresh',
      previous: 'Previous',
      appName: 'Aida',
      rowsPerPage: 'Rows per page',
    },
    // Business
    business: {
      title: "Business Information",
      pageDescription: "Please enter your business information",
      additionalDescription: "This information will be used to improve our services",
      success: "Business information saved successfully",
      businessName: 'Business Name',
      businessNameHelper: 'Please enter your business name',
      businessType: 'Business Type',
      businessTypeHelper: 'Please enter your business type',
      businessSize: 'Business Size',
      businessSizeHelper: 'Please select your business size',
      businessDescription: 'Business Description',
      businessDescriptionHelper: 'Please enter a complete description of your business',
      address: 'Address',
      addressHelper: 'Please enter your business address',
      description: 'Description',
      descriptionHelper: 'Please enter additional business description',
      save: 'Save',
      saving: 'Saving...',
      edit_modal_button: 'Edit Information',
      edit_modal_title: 'Edit Business Information',
      cancel: 'Cancel',
      save_modal: 'Save Changes',
      sizes: {
        small: 'Small',
        medium: 'Medium',
        large: 'Large'
      },
      error: {
        notFound: 'Business information not found. Please complete the registration process first.',
        incomplete: 'Business information is incomplete. Please fill in all required fields.',
        saveError: 'Error saving business information. Please try again.',
        fetchError: 'Error fetching business information. Please try again.',
        sessionExpired: 'Session expired. Please login again.',
        forbidden: 'You do not have permission to make changes in this section.',
        business_name_error: "Business name must have at least 2 characters",
        business_des_error: "Business description must have at least 5 characters",
        address_error: "Address must have at least 6 characters"
      }
    },
    // Service
    service: {
      title: 'Service Information',
      description: 'Please enter your service information',
      serviceType: 'Service Type',
      serviceTypeHelper: 'Please select your service type',
      serviceDescription: 'Service Description',
      serviceDescriptionHelper: 'Please enter a complete description of your services',
      targetAudience: 'Target Audience',
      targetAudienceHelper: 'Please describe your target audience',
      interactionStyle: 'Interaction Style',
      interactionStyleHelper: 'Please select your preferred interaction style',
      proactive: 'Proactive',
      reactive: 'Reactive',
      save: 'Save',
      saveAndContinue: 'Save and Continue',
      saving: 'Saving...',
      success: 'Information updated successfully',
      error: {
        notFound: 'Service information not found. Please complete the registration process first.',
        incomplete: 'Service information is incomplete. Please fill in all required fields.',
        saveError: 'Error saving information. Please try again.',
        fetchError: 'Error fetching service information. Please try again.',
        sessionExpired: 'Session expired. Please login again.',
      },
      types: {
        consultation: 'Consultation',
        training: 'Training',
        service: 'Service',
        other: 'Other',
      },
      interactionStyles: {
        proactive: 'Proactive',
        reactive: 'Reactive',
      },
    },
    // Chatbox
    chatbox: {
      title: 'Chatbox',
      tabs: {
        chatbox: 'Chatbox',
        documentation: 'Documentation',
        chatbox_properties: 'Chatbox Properties',
      },
      settings: {
        title: 'Settings',
        position: 'Position',
        defaultState: 'Default State',
        preview: 'Preview',
        right: 'Right',
        left: 'Left',
        closed: 'Closed',
        open: 'Open',
        timeOpen: {
          title: 'Chatbox open animation delay',
          on: 'On',
          off: 'Off',
          unit: 'seconds',
        },
        processing: {
          title: "Aida's thinking state while responding",
          on: 'On',
          off: 'Off',
        },
      },
      preview: {
        title: 'Preview',
        description: 'This is a preview of the chatbox.',
      },
      message: {
        placeholder: 'Type your message...',
        send: 'Send',
        copy: 'Copy to clipboard',
        copied: 'Copied!',
        emptyMessage: 'Please enter your message.',
        waitForResponse: 'Please wait for the previous response.',
        noChatboxId: 'Chatbox ID not found.',
        websiteAddressNotConfigured: 'Configure the website destination address in channel settings.',
      },
      guide: {
        title: 'Usage Guide',
        description: 'This is a sample chatbox to test and get familiar with Aida chatbox features.',
        documentation: 'For using in your website or application, refer to the documentation.',
      },
      documentation: {
        title: 'Documentation',
        description: 'To use Aida chatbox in your website or application, use the following code:',
        example: {
          title: 'Example',
          description: 'This is a simple example of how to use the chatbox API.',
        },
        integration: {
          title: 'Website Integration',
          description: 'To add the Aida chatbox to any website, simply include the following script tag before the closing <code></body></code> tag:',
          prerequisites: {
            title: 'Prerequisites',
            description: 'Before using the chatbox, make sure to:',
            list: [
              'Set your website URL in Aida → Channels → Website',
              'Enable the website channel',
              'Copy your chatbox ID from the channels page (shown above)'
            ]
          },
          wordpress: {
            title: 'WordPress Integration',
            description: 'To add the chatbox to your WordPress website, you have several options:',
            method1: {
              title: 'Method 1: Using WordPress Customizer',
              steps: [
                'Go to Appearance → Customize in your WordPress admin',
                'Click on Additional CSS or Theme Options',
                'Add the script tag to the footer section'
              ]
            },
            method2: {
              title: 'Method 2: Using a Plugin',
              steps: [
                'Install a plugin like "Insert Headers and Footers" or "Code Snippets"',
                'Go to the plugin settings',
                'Paste the script code in the "Footer" section',
                'Save the changes'
              ]
            },
            method3: {
              title: 'Method 3: Editing Theme Files',
              steps: [
                'Go to Appearance → Theme Editor',
                'Select footer.php from the file list',
                'Add the script tag just before the closing </body> tag',
                'Click Update File'
              ]
            }
          },
          testing: {
            title: 'Testing',
            description: 'After adding the script to your website:',
            steps: [
              'Visit your website in a new browser tab',
              'Look for the Aida chatbox widget (usually appears in the bottom-right corner)',
              'Test sending a message to ensure it\'s working correctly'
            ]
          }
        }
      },
      faq: {
        title: 'FAQ',
        description: 'You can add frequently asked questions here to show at the beginning of the Aida chat box.',
        description2: '!!! After any change, place the script code on your site again.',
        addQuestion: 'Add question',
        question: 'Question',
        placeholderQ: 'e.g.: How much is the subscription?',
        delete: 'Remove',
      },
      didarForm: {
        title: 'Didar Form',
        urlPlaceholder: 'Didar URL link',
        confirmUrl: 'Confirm link',
        fieldLegend: 'Description {title}',
        fieldPlaceholder: 'Describe what you want to collect from the user regarding {title}',
        confirm: 'Confirm',
        invalidUrl: 'Invalid Didar form link. Please enter the full URL or form ID.',
        loadError: 'Failed to load form details. Please try again.',
      },
    },
    // Payments
    payments: {
      title: 'Payments',
      description: 'In this section you can view your payment history',
      date: 'Date',
      amount: 'Amount',
      status: 'Status',
      type: 'Type',
      plan: 'Plan',
      cardNumber: 'Card Number',
      trackingCode: 'Tracking Code',
      invoice: 'Invoice',
      success: 'Success',
      failed: 'Failed',
      pending: 'Pending',
      subscription: 'Subscription',
      renewal: 'Renewal',
      oneTime: 'One-time',
      noPayments: 'No payments found',
      rowsPerPage: 'Rows per page',
      fromDate: 'From Date',
      toDate: 'To Date',
      paymentId: 'Payment ID',
      cash_type: ' Toman',
      error: {
        fetchError: 'Error fetching payment information. Please try again.',
      },
    },
    // Profile
    profile: {
      title: 'Profile',
      description: 'In this section you can view and edit your personal information',
      fullName: 'Full Name',
      fullNameHelper: 'Please enter your full name',
      phoneNumber: 'Phone Number',
      phoneNumberHelper: 'Please enter your phone number with country code',
      position: 'Position',
      positionHelper: 'Please enter your position',
      email: 'Email',
      emailHelper: 'Please enter your email',
      save: 'Save',
      saving: 'Saving...',
      success: 'Information updated successfully',
      edit_profile: 'Edit Profile',
      edit_modal_title: 'Edit Profile Information',
      cancel: 'Cancel',
      save_modal_profile: 'Save Changes',
      error: {
        phone_number_invalid: 'Phone number is invalid.',
        notFound: 'Profile information not found. Please complete the registration process first.',
        incomplete: 'Profile information is incomplete. Please fill in all required fields.',
        saveError: 'Error saving information. Please try again.',
        fetchError: 'Error fetching profile information. Please try again.',
        sessionExpired: 'Session expired. Please login again.',
        phone_pattern_error: "Correct Your Phone number",
        string_pattern_error: "Your name and Your position must have more than 2 character",
        email_error_already_register: "You can't use this email",
        phone_error_already_register: "You can't use this phone number",
      },
    },
    // Conversations
    conversations: {
      title: 'Conversations',
      description: 'In this section you can view and manage your conversations',
      id: 'ID',
      username: 'Username',
      channel: 'Channel',
      inputMessage: 'Input Message',
      outputMessage: 'Output Message',
      inputTokens: 'Input Tokens',
      outputTokens: 'Output Tokens',
      model: 'Model',
      date: 'Date',
      status: 'Status',
      lastMessage: 'Last Message',
      active: 'Active',
      closed: 'Closed',
      noConversations: 'No conversations found',
      filterByUsername: 'Filter by Username',
      startDate: 'Start Date',
      endDate: 'End Date',
      showing: 'Showing {start}-{end} of {total}',
      channels: 'Channels',
      users: 'Users',
      messages: 'Messages',
      clickToViewUsers: 'Click to view users',
      noChannels: 'No channels found',
      noUsers: 'No users found',
      noMessages: 'No messages found',
      moreUsers: 'Show more users',
      loadMoreMessages: 'Show more',
      loadPreviousMessages: 'Show previous messages',
      emptyState: {
        title: 'Connect Aida to your channels and respond to your customers',
        connectInstagram: 'Connect to Instagram',
        connectTelegram: 'Connect to Telegram',
        connectWebsite: 'Connect to Website',
        connectBale: 'Connect to Bale',
        guideLink: 'Conversations page guide',
      },
      guide: {
        title: 'Conversations Page Guide',
        intro: 'On this page, you can view and review all conversations between Aida and your customers.',
        structureIntro: 'The page is organized as a three-column layout, from right to left, including the following sections:',
        channelsTitle: 'Channels',
        channelsDescription: 'In the first column, Aida\'s communication channels are displayed:',
        channelsHint: 'By selecting a channel, the list of people who chatted with Aida through that platform appears in the second column.',
        usersTitle: 'Users',
        usersDescription: 'In the second column, users and customers who communicated with Aida in the selected channel are shown.',
        usersHint: 'Click on any user to view their complete conversation history with Aida.',
        messagesTitle: 'Messages',
        messagesDescription: 'In the third column, the full text of conversations between the customer and Aida is displayed.',
        messagesHint: 'In this section, you can review sent messages, Aida\'s responses, and the full flow of each conversation.',
        purposeIntro: 'The purpose of this page is not just to view conversations; it is a tool for evaluating and improving Aida\'s performance. By reviewing Aida\'s responses, you can:',
        purposeItems: [
          'Identify strengths and weaknesses in responses.',
          'Complete and update Aida\'s knowledge.',
          'Optimize response behavior and settings.',
          'Define new commands and campaigns.',
          'Improve the quality of communication with customers.',
        ],
        closing: 'The more conversations you review and analyze, the better Aida understands your business and the more effective responses it can provide to your customers.',
      },
      error: {
        fetchError: 'Error fetching conversations. Please try again.',
        fetchChannelsError: 'Error fetching channels list. Please try again.',
        fetchUsersError: 'Error fetching users list. Please try again.',
        fetchMessagesError: 'Error fetching messages. Please try again.',
        sessionExpired: 'Session expired. Please login again.',
      },
    },
    // Knowledge
    knowledge: {
      add: {
        title: 'Add Knowledge',
        description: 'In this section you can add new knowledge to Aida',
        type: 'Knowledge Type',
        content: 'Content',
        uploadPdf: 'Upload PDF',
        uploadExcel: 'Upload Excel (.xlsx)',
        uploadCsv: 'Upload CSV (.csv)',
        url: 'Article URL',
        deletedAt: 'Expiration Date (optional)',
        selectedFile: 'Selected File',
        save: 'Save',
        saving: 'Saving...',
        success: 'Knowledge added successfully',
        error: {
          incomplete: 'Information is incomplete. Please fill in all required fields.',
          saveError: 'Error saving knowledge. Please try again.',
        },
        instructions: {
          product: 'The Excel file must be exported from DidarCRM and must contain the following columns: Product Title, Product Unit, Unit Price, Currency Unit, Product Group, Invoice Title.',
          faq: 'The CSV file must contain the columns: question and answer.',
          contact: 'The CSV file must contain the columns: name, role, email, and description.',
          kb_article: 'Enter a URL to a knowledge base article or web page to extract its content.',
          text: 'Enter any plain text to add as knowledge.',
          pdf: 'Upload a PDF file to extract and add its content as knowledge.',
        },
        cancel: 'Cancel Add Knowledge',
      },
      stats: {
        title: 'Knowledge Stats',
        description: 'In this section you can view Aida knowledge statistics',
        total: 'Total Knowledge',
        totalEntries: 'Total Entries',
        totalCharacters: 'Total Characters',
        estimatedTokens: 'Estimated Tokens',
        estimatedCost: 'Estimated Cost',
        lastUpdated: 'Last Updated',
        notUpdated: 'Not Updated Yet',
        error: {
          fetchError: 'Error fetching knowledge stats. Please try again.',
          sessionExpired: 'Session expired. Please login again.',
        },
      },
      flush: {
        title: 'Flush Knowledge',
        description: 'In this section you can flush Aida knowledge',
        confirm: 'Are you sure you want to flush the knowledge?',
        deleteAll: 'Delete All Knowledge',
        success: 'Knowledge flushed successfully',
        error: {
          flushError: 'Error flushing knowledge. Please try again.',
        },
        confirmDescription: 'All knowledge will be deleted and will not be recoverable.',
        delete: 'Delete All Knowledge',
      },
      list: {
        title: 'List of the Knowledge',
        id: 'ID',
        sourceType: 'Source Type',
        sourceName: 'Source Name',
        content: 'Content',
        createdAt: 'Created At',
        updatedAt: 'Updated At',
        actions: 'Actions',
        empty: 'No knowledge entries found.',
        confirmDeleteTitle: 'Confirm Delete',
        confirmDelete: 'Are you sure you want to delete this knowledge entry?',
        delete: 'Delete',
        showMore: 'Show more',
        showLess: 'Show less',
        upgradeMessage: 'The knowledge system is going to upgrade. It will take until Monday, 1 December 2025.',
        success: {
          delete: 'Knowledge deleted successfully.',
        },
        error: {
          fetchError: 'Error fetching knowledge list.',
          deleteError: 'Error deleting knowledge.',
          sessionExpired: 'Session expired. Please login again.',
        },
      },
    },
    // Automation
    automation: {
      table:{
        direct: "Direct",
        comment: "Comment",
        both: "Both",
        equals: "Equals",
        contains: "Contains",
        id: "ID",
        channelType: "Channel Type",
        conditionType: "Condition Type",
        triggerValue: "Trigger Value",
        responseMessage: "Response Message",
        status: "Status",
        createdAt: "Created At",
        operations: "Operations",
        active: "active/inactive",
      },
      automation_bot: {
        error: {
          sessionExpired: "Your session has expired. Please login again.",
          deleteError: "Error deleting command",
          pick_channel: "Please select at least one channel type",
          enter_trigger: "Please enter a trigger word or phrase",
          enter_response: "Please enter a response message",
          toggleActive: "Error changing status",
        },
        success: {
          delete: "Command deleted successfully",
          add: "Command added successfully",
          update: "Command updated successfully",
          toggleActive: "Status changed successfully",
        },
        edit: {
          title: "Edit Command",
          update: "Update",
        },
        add: {
          title: "Add Command",
          success: "Command added successfully",
          error: "Error adding command",
          cancel: "Cancel",
          type: "Command Type",
          content: "Content",
          url: "Link",
          uploadCsv: "Upload CSV",
          uploadExcel: "Upload Excel",
          uploadPdf: "Upload PDF",
          uploadText: "Upload Text",
          selectedFile: "Selected file: {fileName}",
          deletedAt: "Delete Time",
          save: "Save",
          commandDetails: "Command Details",
          ifUserSends: "If your user sends",
          direct: "Direct",
          comment: "Comment (Post and Live)",
          wordOrPhrase: "a word or phrase",
          conditionMode: "Condition Mode",
          equals: "Equals",
          contains: "Contains",
          value: "Value",
          willSendMessage: "the following message will be sent to them",
          responseMessage: "Response Message",
          create: "Create",
          selectChannelType: "Please select at least one channel type",
          enterTriggerValue: "Please enter a trigger word or phrase",
          enterResponseMessage: "Please enter a response message",
          button_text: "Button Text",
          has_button_in_response: "Has Button in Response",
          button_url: "Button URL",
        },
        flush: {
          deleteAll: "Delete All Commands",
          success: "Commands deleted successfully",
          confirm: "Confirm Delete All Commands",
          confirmDescription: "Are you sure you want to delete all commands?",
          delete: "Delete",
        },
        list: {
          title: "Commands",
          empty: "No commands found",
          id: "ID",
          channelType: "Channel Type",
          conditionType: "Condition Type",
          triggerValue: "Trigger Value",
          responseMessage: "Response Message",
          status: "Status",
          createdAt: "Created At",
          updatedAt: "Updated At",
          actions: "Actions",
          showLess: "Show Less",
          showMore: "Show More",
          confirmDeleteTitle: "Confirm Delete",
          confirmDelete: "Are you sure you want to delete this command?",
          delete: "Delete",
          active: "Active",
          inactive: "Inactive",
          direct: "Direct",
          comment: "Comment",
          both: "Direct and Comment",
          equals: "Equals",
          contains: "Contains",
        }
      },
    },
    // Behavior
    behavior: {
      title: 'Aida Behavior',
      description: 'In this section you can configure Aida behavior and response style',
      save: 'Save',
      saving: 'Saving...',
      success: 'Behavior settings updated successfully',
      systemPrompt: {
        success: 'Aida System Prompt updated successfully',
        error: 'Error updating Aida System Prompt',
        open: 'Aida System Prompt opened',
        close: 'Aida System Prompt locked',
        errorlock: 'Error changing Aida System Prompt status',
        editTitle: 'Edit Aida System Prompt',
        placeholder: 'Enter Aida System Prompt here...',
        cancel: 'Cancel',
        save: 'Save',
        title: 'Aida System Prompt',
      },
      error: {
        fetchError: 'Error fetching behavior settings. Please try again.',
        saveError: 'Error saving behavior settings. Please try again.',
        Aida_notFound: 'Aida is not active.',
        sessionExpired: 'Session expired. Please login again.',
      },
      conversionStyle: {
        title: 'Conversation Style',
        description: 'This setting determines how Aida interacts with users',
        proactive: {
          title: 'Proactive',
          description: 'Aida asks questions to help the conversation continue and not stop',
        },
        reactive: {
          title: 'Reactive',
          description: 'Aida only responds to user questions and does not ask questions',
        },
        rejex: {
          title: 'Response Styles',
          description: 'Aida only responds to user questions and does not ask questions',
          noFilters: 'No filters available',
          active: 'Active',
          inactive: 'Inactive',
        },
      },
      lengthOfResponse: {
        title: 'Length of Response',
        description: 'In this section you can set the length of Aida\'s responses',
        long: {
          title: 'Long Responses',
          description: 'Aida provides long and detailed responses',
        },
        medium: {
          title: 'Medium Responses',
          description: 'Aida provides medium responses',
        },
        short: {
          title: 'Short Responses',
          description: 'Aida provides short and concise responses',
        },
      },
      salesRole: {
        title: 'Sales Role',
        description: 'Determines who Aida is used by',
        representative: {
          title: 'Sales Representative',
          description: 'Aida is used by buyers who want to buy something from you',
        },
        assistant: {
          title: 'Sales Assistant',
          description: 'Aida is used by your sellers as an assistant to enrich the sales process',
        },
      },
      salesMethodology: {
        title: 'Sales Methodology',
        description: 'Choose the appropriate sales method for your business',
        labels: {
          goal: 'Goal:',
          tone: 'Tone:',
          structure: 'Structure:',
          role: 'Role:'
        },
        consultative: {
          title: 'Consultative',
          role: 'Trusted advisor',
          goal: 'Understand the client\'s world deeply',
          tone: 'Empathetic, curious, supportive',
          structure: 'Open-ended → exploratory → advisory',
          description: 'Best choice for complex services that require deep understanding of customer needs',
        },
        transactional: {
          title: 'Transactional',
          role: 'Fast-acting closer',
          goal: 'Provide key info and close the deal',
          tone: 'Efficient, direct, persuasive',
          structure: 'Feature → Benefit → Close',
          description: 'Suitable for simple, low-cost products that don\'t require much explanation',
        },
        solutionBased: {
          title: 'Solution-Based',
          role: 'Solution architect',
          goal: 'Link customer pain to product capabilities',
          tone: 'Analytical, problem-solving',
          structure: 'Diagnose → Match → Prove Value',
          description: 'Best choice for technology products or complex services that solve specific problems',
        },
        challenger: {
          title: 'Challenger',
          role: 'Insightful provocateur',
          goal: 'Reframe the user\'s thinking',
          tone: 'Bold, authoritative, educational',
          structure: 'Teach → Tailor → Take Control',
          description: 'Suitable for competitive markets that require changing customer mindset',
        },
        spin: {
          title: 'SPIN',
          role: 'Diagnostic interviewer',
          goal: 'Lead user to realize the need themselves',
          tone: 'Inquisitive, methodical',
          structure: 'Situation → Problem → Implication → Need-payoff',
          description: 'Best choice for complex B2B sales that require discovering hidden needs',
        },
        sandler: {
          title: 'Sandler',
          role: 'Trusted equal, emotionally intelligent guide',
          goal: 'Qualify the user emotionally and logically before offering a solution',
          tone: 'Calm, probing, psychological',
          structure: 'Rapport → Pain → Budget/Decision → Post-sell',
          description: 'Suitable for high-value sales that require deep trust',
        },
      },
      salesTime: {
        title: 'Time to Rest Aida',
        description: 'In this section you can set the time to rest Aida that Aida will not respond to the users',
        addRestTime: 'Add Rest Time',
        cancel: 'Cancel',
        restDay: 'Rest Day',
        days:{
          saturday: 'Saturday',
          sunday: 'Sunday',
          monday: 'Monday',
          tuesday: 'Tuesday',
          wednesday: 'Wednesday',
          thursday: 'Thursday',
          friday: 'Friday',
        },
        restTime: 'Rest Time',
        emptyDescription: 'Aida is powerful and dedicated to providing services to you dear friend.',
        table:{
          restDay: 'Rest Day',
          startTime: 'Start Time',
          endTime: 'End Time',
          actions: 'Actions',
        },
        error: {
          timeRequired: 'Time is required',
          timeFormat: 'Time format must be HH:MM',
          timeHour: 'Time hour must be a number',
          timeMinute: 'Time minute must be a number',
          timeStartBeforeEnd: 'Time start must be before time end',
          timeOverlaps: 'Time ranges must not overlap',
          timeHourMin: 'Time hour must be greater than 0',
          timeHourMax: 'Time hour must be less than 23',
          timeMinuteMin: 'Time minute must be greater than 0',
          timeMinuteMax: 'Time minute must be less than 59',
          errorDelete: 'Error deleting rest time.',
        },
        success: 'Rest time added successfully',
      },
      advanced_setting: {
        advanced_setting: 'Aida Advanced Settings',
        lock_open: 'Task unlocked',
        lock_close: 'Task locked',
        lock_error: 'Error changing task lock status',
        ok_edit: 'Task updated successfully',
        error_edit: 'Error updating task',
        ok_add: 'Task added successfully',
        error_add: 'Error adding task',
        ok_delete: 'Task deleted successfully',
        error_delete: 'Error deleting task',
        add_subtask_: 'Add Task',
        days: {
          saturday: 'saturday',
          sunday: 'sunday',
          monday: 'monday',
          tuesday: 'tuesday',
          wednesday: 'wednesday',
          thursday: 'thursday',
          friday: 'friday',
        },
        error_fetch: 'Error fetching tasks',
        zero_fetch: 'No tasks found',
        subtask:'Aida Task',
        subtask_reason: 'Task reason',
        subtask_kpi: 'Task success indicator',
        description: 'Description',
        reason: 'Reason',
        kpi: 'Success Indicator',
        cancel: 'cancel',
        ok: 'ok',
        add_subtask: 'Add New Task',
        add_subtask_des: 'In the task section, you can write the task that you want Aida to do.',
        add_subtask_des2: 'In the reason section, you can enter the reason why Aida should do the task you specified.',
        add_subtask_des3: 'In the success indicator section, you can specify the success indicator of Aida in doing the task you gave him.',
        delete_subtask: {
          confirm: 'Confirm Delete Task',
          description: 'Are you sure you want to delete this task?',
          notback: 'This action is not reversible.',
          deleteit: 'Delete',
          cancelit: 'Cancel'
        },
        descriptiontext: {
          des1: 'In the advanced settings section, you can specify the tasks that Aida should do. Aida automatically categorizes the tasks and instructions needed based on the information you provide. However, if you feel Aida should also have other tasks or tasks in your program, you can add the tasks you want using the add task button.',
          des2: 'Note that with each change in your information, Aida\'s automatic tasks may also change. Therefore, if a task is very important to you and you do not want it to change, you can lock it using the lock button. You can also edit the information of each task using the edit button and delete it if you do not need a task.',
          des3: 'Currently, there is a maximum of 10 tasks for Aida. The number of tasks that can be added is displayed in the add task button and after reaching the limit, this button will be automatically disabled.',
        }
      },
      tabs: {
        tab1: 'General',
        tab2: 'Sales Methodology',
        tab3: 'Advanced Settings',
      },
    }
  },
  validation: {
    phoneValidationPattern: 'Phone number must be in the format +989123456789',
    phoneValidationRequired: 'Phone number is required',
    emailValidation: 'Email is invalid',
    emailValidationRequired: 'Email is required',
    otpValidationPattern: 'OTP must be 6 digits',
    otpValidationRequired: 'OTP is required',
    fullNameValidationRequired: 'Full name is required',
    fullNameValidationMin: 'Full name must be at least 3 characters',
    positionValidationRequired: 'Position is required',
    positionValidationMin: 'Position must be at least 2 characters',
    bussinessDescriptionValidationRequired: 'Business description is required',
    bussinessDescriptionValidationMin: 'Business description must be at least 10 characters',
    businessNameValidation: 'Business name is invalid',
    businessNameValidationRequired: 'Business name is required',
    serviceTypeValidationRequired: 'Service type is required',
    serviceTypeValidationMin: 'Service type must be at least 2 characters',
    serviceDescriptionValidationRequired: 'Service description is required',
    serviceDescriptionValidationMin: 'Service description must be at least 10 characters',
    targetAudienceValidationRequired: 'Target audience is required',
    targetAudienceValidationMin: 'Target audience must be at least 10 characters',
    interactionStyleValidation: 'Interaction style is invalid',
    interactionStyleValidationRequired: 'Interaction style is required',
    instagramUsernameValidationRequired: 'Instagram username is required',
    instagramUsernameValidationMin: 'Instagram username must be at least 3 characters',
    instagramPasswordValidationRequired: 'Instagram password is required',
    instagramPasswordValidationMin: 'Instagram password must be at least 6 characters',
    channelsValidationRequired: 'Channels are required',
    channelsValidationMin: 'Channels must be at least 1 character',
    planValidationRequired: 'Plan is required',
    durationValidation: 'Duration is invalid',
    durationValidationRequired: 'Duration is required',
  },
  knowledgeBase: {
    tabs: {
      tab1: 'Knowledge Management',
      tab3: 'Knowledge Graph',
      tab2: 'Knowledge Conversation',
    },
    noAccess: 'You do not have access to any knowledge base sections.',
  },
  aidaSettings: {
    tabs: {
      tab1: 'Knowledge',
      tab2: 'Tasks',
      tab3: 'Campaigns',
      tab4: 'Connections',
      tab5: 'Behavior',
      tab6: 'Settings',
    },
  },
  profileAndBusiness: {
    tabs: {
      profile: 'profile',
      business: 'business',
    },
  },
}; 